/* PAULS MOTOR V35 – EN JS-FIL: FILTERRETUR (FORDONSLISTA) + JÄMFÖR/DELA (PRODUKTSIDA) */
/* Lägg samma asset pauls-vehicle-tools-v1.js i fordonslistans Section också. */

/*
 * PAULS MOTOR | Filterretur V33
 * Behåll detta asset-namn i Shopify: pauls-vehicle-filter-state-v1.js
 * Spara urvalet i PRODUKTLÄNKEN. Samma länk går att öppna i en ny flik.
 * Återställ via URL på väg tillbaka. SessionStorage används bara som reserv.
 */
(() => {
  'use strict';
  if (window.__pmvFilterSessionV33) return;
  window.__pmvFilterSessionV33 = true;

  const COLLECTION_PATH = '/collections/fordon-till-salu';
  if (location.pathname.replace(/\/$/, '') !== COLLECTION_PATH) return;

  const KEY = 'pmv_vehicle_filter_context_v1';
  const URL_KEY = 'pmv_filters';
  const MAX_AGE = 2 * 60 * 60 * 1000;
  const FIELDS = new Set(['brand','type','fuel','color','condition','equipment']);
  const RANGE_FIELDS = new Set(['engine','price','year','mileage']);
  const SORTS = new Set(['newest','default','price-asc','price-desc','year-desc','mileage-asc']);
  let restoring = false;
  let timer = 0;

  function rootNode() {
    return document.querySelector('[data-pmv-root]');
  }

  function cleanState(value) {
    if (!value || value.version !== 1 || !Number.isFinite(value.savedAt) ||
        Date.now() - value.savedAt > MAX_AGE || value.savedAt > Date.now() + 60000 ||
        !Array.isArray(value.filters) || !value.ranges || typeof value.ranges !== 'object') {
      return null;
    }
    const filters = value.filters.slice(0, 40)
      .filter(item => item && FIELDS.has(item.field) &&
        typeof item.value === 'string' && item.value.length <= 100)
      .map(item => ({
        field: item.field, value: item.value,
        label: String(item.label || item.value).slice(0, 75)
      }));
    const ranges = {};
    Object.keys(value.ranges).forEach(field => {
      const r = value.ranges[field];
      if (!RANGE_FIELDS.has(field) || !r || !r.active) return;
      if (!Number.isFinite(Number(r.min)) || !Number.isFinite(Number(r.max))) return;
      ranges[field] = { active: true, min: Number(r.min), max: Number(r.max) };
    });
    return {
      version: 1,
      savedAt: value.savedAt,
      filters, ranges,
      query: typeof value.query === 'string' ? value.query.slice(0, 130) : '',
      sort: SORTS.has(value.sort) ? value.sort : 'newest'
    };
  }

  function fromUrl() {
    try {
      const raw = new URLSearchParams(location.search).get(URL_KEY);
      if (!raw || raw.length > 10000) return null;
      return cleanState(JSON.parse(raw));
    } catch (_) {
      return null;
    }
  }

  function fromStorage() {
    try { return cleanState(JSON.parse(sessionStorage.getItem(KEY) || 'null')); }
    catch (_) { return null; }
  }

  function capture() {
    const root = rootNode();
    if (!root) return null;
    const filters = Array.from(root.querySelectorAll('input[data-filter-field]:checked'))
      .map(input => ({
        field: String(input.dataset.filterField || ''),
        value: String(input.value || ''),
        label: String(input.closest('.pmv__option')?.querySelector('.pmv__option-name')?.textContent || input.value || '').trim().slice(0, 75)
      })).filter(item => FIELDS.has(item.field) && item.value).slice(0, 40);

    const ranges = {};
    root.querySelectorAll('[data-range]').forEach(group => {
      const field = String(group.dataset.range || '');
      if (!RANGE_FIELDS.has(field)) return;
      // The collection's own JS synchronizes slider and number fields.
      const minSlider = group.querySelector('[data-range-min-slider]');
      const maxSlider = group.querySelector('[data-range-max-slider]');
      if (!minSlider || !maxSlider || group.classList.contains('is-unavailable')) return;
      const min = Number(minSlider.value);
      const max = Number(maxSlider.value);
      const low = Number(minSlider.min);
      const high = Number(maxSlider.max);
      if (![min, max, low, high].every(Number.isFinite)) return;
      if (min > low || max < high) ranges[field] = { active: true, min, max };
    });

    const search = root.querySelector('[data-pmv-search]');
    const sorts = Array.from(root.querySelectorAll('[data-pmv-sort]'));
    const activeSort = sorts.find(el => el.offsetParent !== null) || sorts[0];
    const state = {
      version: 1, savedAt: Date.now(), filters, ranges,
      query: search ? String(search.value || '').slice(0, 130) : '',
      sort: activeSort && SORTS.has(activeSort.value) ? activeSort.value : 'newest'
    };
    return state;
  }

  function saveState(state) {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {}
  }

  function stateInUrl(state) {
    return state.filters.length > 0 || state.query.trim() ||
      Object.keys(state.ranges).length > 0 || state.sort !== 'newest';
  }

  function decorateProductLinks(state) {
    const root = rootNode();
    if (!root) return;
    root.querySelectorAll('a.pmv-card__link').forEach(link => {
      try {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return;
        if (stateInUrl(state)) {
          url.searchParams.set(URL_KEY, JSON.stringify(state));
        } else {
          url.searchParams.delete(URL_KEY);
        }
        link.href = url.pathname + url.search + url.hash;
      } catch (_) {}
    });
  }

  function saveAndDecorate() {
    if (restoring) return;
    const state = capture();
    if (!state) return;
    saveState(state);
    decorateProductLinks(state);
  }

  function scheduleSave() {
    if (restoring) return;
    clearTimeout(timer);
    timer = setTimeout(saveAndDecorate, 60);
  }

  function applyRange(root, field, values) {
    const group = root.querySelector('[data-range="' + field + '"]');
    if (!group || group.classList.contains('is-unavailable')) return;
    const minSlider = group.querySelector('[data-range-min-slider]');
    const maxSlider = group.querySelector('[data-range-max-slider]');
    if (!minSlider || !maxSlider) return;
    const low = Number(minSlider.min);
    const high = Number(maxSlider.max);
    if (![low, high].every(Number.isFinite)) return;
    const min = Math.max(low, Math.min(high, Number(values.min)));
    const max = Math.max(min, Math.min(high, Number(values.max)));
    // The original collection JS stores a separate range.userActive property.
    // Dispatching events is required, setting the input value alone does not filter.
    maxSlider.value = String(max);
    maxSlider.dispatchEvent(new Event('input', { bubbles: true }));
    minSlider.value = String(min);
    minSlider.dispatchEvent(new Event('input', { bubbles: true }));
    minSlider.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function restore(state) {
    const root = rootNode();
    if (!root) return;
    restoring = true;
    const selected = new Set(state.filters.map(item => item.field + '\u0000' + item.value));
    const boxes = Array.from(root.querySelectorAll('input[data-filter-field]'));
    boxes.forEach(input => {
      const checked = selected.has(String(input.dataset.filterField || '') + '\u0000' + String(input.value || ''));
      input.checked = checked;
      const row = input.closest('.pmv__option');
      if (row) row.classList.toggle('is-selected', checked);
    });
    // Triggers the existing collection's fullRefresh() and updates count immediately.
    if (boxes.length) boxes[0].dispatchEvent(new Event('change', { bubbles: true }));

    const search = root.querySelector('[data-pmv-search]');
    if (search) {
      search.value = state.query;
      search.dispatchEvent(new Event('input', { bubbles: true }));
    }

    setTimeout(() => {
      for (const field of ['engine','price','year','mileage']) {
        if (state.ranges[field]) applyRange(root, field, state.ranges[field]);
      }
      const selects = Array.from(root.querySelectorAll('[data-pmv-sort]'));
      if (selects.length && SORTS.has(state.sort)) {
        selects.forEach(select => { select.value = state.sort; });
        selects[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      setTimeout(() => {
        restoring = false;
        saveAndDecorate();
        // Do not expose lengthy filter payload on collection URL after restoration.
        // Product links remain self-contained for the next navigation.
        try {
          const clean = new URL(location.href);
          clean.searchParams.delete(URL_KEY);
          clean.searchParams.delete('pmv_return');
          history.replaceState(history.state, '', clean.pathname + clean.search + clean.hash);
        } catch (_) {}
      }, 240);
    }, 40);
  }

  function init() {
    const root = rootNode();
    if (!root) return;
    const params = new URLSearchParams(location.search);
    const restoreRequest = params.get('pmv_return') === '1' || !!params.get(URL_KEY);
    // Always prefer state in the URL. Session is a fallback for old V32 links.
    const state = restoreRequest ? (fromUrl() || fromStorage()) : null;

    root.addEventListener('input', e => {
      if (e.target.matches('[data-pmv-search],[data-range-min-slider],[data-range-max-slider],[data-range-min-input],[data-range-max-input]')) scheduleSave();
    });
    root.addEventListener('change', e => {
      if (e.target.matches('[data-filter-field],[data-pmv-sort],[data-range-min-slider],[data-range-max-slider],[data-range-min-input],[data-range-max-input]')) scheduleSave();
    });
    root.addEventListener('click', e => {
      if (e.target.closest('[data-pmv-reset]')) setTimeout(saveAndDecorate, 0);
    });
    // Capture phase updates href BEFORE the browser follows the link.
    root.addEventListener('click', e => {
      const a = e.target.closest('a.pmv-card__link');
      if (a && !restoring) saveAndDecorate();
    }, true);
    window.addEventListener('pagehide', saveAndDecorate);
    window.addEventListener('pageshow', e => {
      if (e.persisted && !restoring) saveAndDecorate();
    });

    if (state) restore(state);
    else saveAndDecorate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


(() => {
  'use strict';

  const root = document.querySelector('[data-pmvp-root]');
  if (!root || root.dataset.pmvtV33Initialized === '1') return;
  root.dataset.pmvtV33Initialized = '1';

  const $ = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

  const esc = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const fmt = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 });

  // Shared session context saved by the lightweight vehicle collection helper.
  // Deliberately uses a fixed collection path: old browser state cannot inject an external URL.
  const COLLECTION_PATH = '/collections/fordon-till-salu';
  const FILTER_CONTEXT_KEY = 'pmv_vehicle_filter_context_v1';
  const FILTER_MAX_AGE = 2 * 60 * 60 * 1000;

  // Filter state is carried by the PRODUCT URL, not just sessionStorage.
  // This also works when a product is opened in a new tab.
  const FILTER_URL_KEY = 'pmv_filters';
  const FILTER_ALLOWED_FIELDS = new Set(['brand','type','fuel','color','condition','equipment']);
  const FILTER_ALLOWED_RANGES = new Set(['engine','price','year','mileage']);

  function validateFilterContext(value) {
    if (!value || value.version !== 1 || !Array.isArray(value.filters) ||
        !value.ranges || typeof value.ranges !== 'object' ||
        !Number.isFinite(value.savedAt) ||
        Date.now() - value.savedAt > FILTER_MAX_AGE ||
        value.savedAt > Date.now() + 60000) return null;

    const filters = value.filters.slice(0, 40)
      .filter(item => item && FILTER_ALLOWED_FIELDS.has(item.field) &&
        typeof item.value === 'string' && item.value.length <= 100)
      .map(item => ({
        field: item.field,
        value: item.value,
        label: String(item.label || item.value).slice(0, 75)
      }));
    const ranges = {};
    Object.entries(value.ranges).forEach(([field, data]) => {
      if (!FILTER_ALLOWED_RANGES.has(field) || !data || !data.active) return;
      if (!Number.isFinite(Number(data.min)) || !Number.isFinite(Number(data.max))) return;
      ranges[field] = { active: true, min: Number(data.min), max: Number(data.max) };
    });
    const sort = typeof value.sort === 'string' ? value.sort.slice(0, 35) : 'newest';
    return {
      version: 1, savedAt: value.savedAt,
      query: typeof value.query === 'string' ? value.query.slice(0, 130) : '',
      filters, ranges, sort
    };
  }

  function filterContext() {
    // Prefer a self-contained URL over possibly stale or unavailable browser storage.
    try {
      const raw = new URLSearchParams(location.search).get(FILTER_URL_KEY);
      if (raw && raw.length <= 10000) {
        const fromUrl = validateFilterContext(JSON.parse(raw));
        if (fromUrl) {
          try { sessionStorage.setItem(FILTER_CONTEXT_KEY, JSON.stringify(fromUrl)); } catch (_) {}
          return fromUrl;
        }
      }
    } catch (_) {}

    try {
      const fromStorage = validateFilterContext(
        JSON.parse(sessionStorage.getItem(FILTER_CONTEXT_KEY) || 'null')
      );
      return fromStorage;
    } catch (_) {
      return null;
    }
  }

  function collectionReturnUrl() {
    const state = filterContext();
    if (state) {
      const params = new URLSearchParams();
      params.set('pmv_return', '1');
      params.set(FILTER_URL_KEY, JSON.stringify(state));
      return COLLECTION_PATH + '?' + params.toString();
    }
    try {
      const ref = new URL(document.referrer);
      if (ref.origin === location.origin &&
          ref.pathname.replace(/\/$/, '') === COLLECTION_PATH) {
        return COLLECTION_PATH + ref.search;
      }
    } catch (_) {}
    return COLLECTION_PATH;
  }

  // The back link preserves all filters, without displaying a breadcrumb trail.
  function renderCollectionBreadcrumb() {
    const topbar = $('.pmvp__topbar');
    if (!topbar) return;

    // Clean up breadcrumb markup from older releases, if still present.
    $$('.pmvt-filter-trail').forEach(trail => trail.remove());

    const back = $('.pmvp__backlink', topbar);
    if (!back) return;
    back.href = collectionReturnUrl();
    back.innerHTML = '<span aria-hidden="true">←</span> Tillbaka till resultaten';
  }

  const product = {
    id: String(root.dataset.productId || ''),
    handle: String(root.dataset.productHandle || ''),
    title: String(root.dataset.productTitle || document.title || ''),
    url: String(root.dataset.productUrl || location.href),
    image: String(root.dataset.productImage || ''),
    price: Number(root.dataset.priceSek || 0),
    reg: String(root.dataset.reg || ''),
    vin: String(root.dataset.vin || ''),
    year: String(root.dataset.modelYear || ''),
    brand: String(root.dataset.brand || '')
  };

  function money(value) {
    return fmt.format(Math.round(Number(value || 0))) + ' kr';
  }

  function toast(message) {
    let el = document.querySelector('.pmvt-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pmvt-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('is-visible'), 1800);
  }

  function injectCss() {
    if (document.getElementById('pmvt-style-v33')) return;

    const style = document.createElement('style');
    style.id = 'pmvt-style-v33';
    style.textContent = `
      /* Quick actions are placed directly beside “Alla fordon”, not in the popup. */
      [data-pmvp-root] .pmvp__top-actions{
        display:flex;align-items:center;justify-content:flex-end;flex-wrap:nowrap;
        gap:7px;min-width:0
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button{
        display:inline-flex;align-items:center;justify-content:center;gap:7px;
        height:36px;min-height:36px;padding:0 12px;
        border:1px solid #d8dde0;border-radius:10px;
        background:#fff;color:#17191a;cursor:pointer;
        font:800 11px/1 system-ui!important;white-space:nowrap;transition:.16s
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button:hover{
        border-color:#f58220;color:#cc650d;background:#fff8f1
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button:focus-visible{
        outline:2px solid #f58220;outline-offset:2px
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button--more{
        width:38px;min-width:38px;padding:0
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button svg{
        width:16px;height:16px;flex:0 0 16px;fill:none;stroke:currentColor;
        stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button--more svg{
        width:18px;height:18px;flex-basis:18px
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-count{
        display:inline-flex;align-items:center;justify-content:center;
        min-width:17px;height:17px;padding:0 4px;border-radius:999px;
        background:#f58220;color:#fff;font:850 9px/1 system-ui
      }
      [data-pmvp-root] .pmvp__top-actions .pmvt-count[hidden]{display:none!important}
      @media(max-width:390px){
        [data-pmvp-root] .pmvp__top-actions{gap:4px}
        [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button{
          height:34px;min-height:34px;padding:0 7px;gap:4px;font-size:10px!important
        }
        [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button--more{
          width:34px;min-width:34px;padding:0
        }
        [data-pmvp-root] .pmvp__top-actions .pmvt-tool-button:not(.pmvt-tool-button--more) svg{
          width:14px;height:14px;flex-basis:14px
        }
      }

      .pmvt-overlay{
        position:fixed;inset:0;z-index:2147482000;background:rgba(7,9,10,.45);
        display:none;align-items:flex-start;justify-content:flex-end;padding:82px 24px 24px
      }
      .pmvt-overlay.is-open{display:flex}
      .pmvt-panel{
        width:min(410px,calc(100vw - 28px));max-height:calc(100vh - 110px);overflow:auto;
        background:#fff;border-radius:17px;box-shadow:0 22px 70px rgba(0,0,0,.24);
        border:1px solid #e2e5e7
      }
      .pmvt-head{
        display:flex;align-items:flex-start;justify-content:space-between;gap:14px;
        padding:17px 17px 14px;border-bottom:1px solid #eceeef
      }
      .pmvt-head>div{min-width:0}
      .pmvt-head strong{display:block;font:900 17px/1.15 system-ui;color:#111}
      .pmvt-head small{display:block;margin-top:4px;color:#7a8286;font:650 10px/1.35 system-ui}
      .pmvt-close{
        display:inline-flex;align-items:center;justify-content:center;
        width:34px;height:34px;flex:0 0 34px;border:0;border-radius:9px;
        background:#f3f4f5;color:#111;font-size:21px;cursor:pointer
      }
      .pmvt-body{padding:14px}
      .pmvt-section+.pmvt-section{margin-top:15px;padding-top:14px;border-top:1px solid #eceeef}
      .pmvt-label{
        margin:0 0 8px;color:#747d81;font-size:9px;font-weight:950;
        letter-spacing:.09em;text-transform:uppercase
      }
      .pmvt-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px}
      .pmvt-action{
        display:flex;align-items:center;gap:9px;min-height:44px;padding:10px 11px;
        border:1px solid #dfe3e5;border-radius:10px;background:#fff;color:#17191a;
        text-decoration:none;font:800 11px/1.25 system-ui;cursor:pointer;text-align:left
      }
      .pmvt-action:hover{border-color:#f58220;background:#fffaf6}
      .pmvt-action--wide{grid-column:1/-1}
      .pmvt-action--orange{background:#f58220;border-color:#f58220;color:#fff}
      .pmvt-action--orange:hover{background:#ea7616;color:#fff}
      .pmvt-action--compare{min-height:60px;background:#111;color:#fff;border-color:#111}
      .pmvt-action--compare:hover{background:#1d1f20;color:#fff;border-color:#1d1f20}
      .pmvt-action--subtle{background:#fafafa}
      .pmvt-action>span:not(.pmvt-action__icon){
        display:flex;flex-direction:column;gap:2px;min-width:0
      }
      .pmvt-action>span>strong{font:850 11px/1.2 system-ui}
      .pmvt-action>span>small{color:#7c8488;font:650 9px/1.3 system-ui}
      .pmvt-action--orange>span>small,
      .pmvt-action--compare>span>small{color:rgba(255,255,255,.76)}
      .pmvt-action__icon{
        display:inline-flex;align-items:center;justify-content:center;
        width:29px;height:29px;flex:0 0 29px;border-radius:8px;
        background:#f4f5f5;color:#202426
      }
      .pmvt-action--orange .pmvt-action__icon,
      .pmvt-action--compare .pmvt-action__icon{
        background:rgba(255,255,255,.15);color:#fff
      }
      .pmvt-action__icon svg{
        width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:1.8;
        stroke-linecap:round;stroke-linejoin:round
      }
      .pmvt-grid--documents{grid-template-columns:1fr 1fr}

      .pmvt-panel{width:min(470px,calc(100vw - 28px));max-height:min(86dvh,800px)}
      .pmvt-panel .pmvt-head strong{font-size:18px}
      .pmvt-selection-header{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px}
      .pmvt-selection-header .pmvt-label{margin:0}
      .pmvt-selection-count{color:#697176;font:800 10px system-ui}
      .pmvt-selected-list{display:grid;gap:8px}
      .pmvt-selected-card{
        display:grid;grid-template-columns:64px minmax(0,1fr) auto;align-items:center;gap:10px;
        padding:8px;border:1px solid #e3e6e7;border-radius:11px;background:#fff
      }
      .pmvt-selected-image{width:64px;height:52px;border-radius:7px;object-fit:cover;background:#eef0f1}
      .pmvt-selected-details{min-width:0}
      .pmvt-selected-details strong{display:block;color:#17191a;font:850 11px/1.32 system-ui;overflow-wrap:anywhere}
      .pmvt-selected-details small{display:block;margin-top:4px;color:#d46f17;font:850 10px system-ui}
      .pmvt-selected-remove{border:1px solid #dce1e4;border-radius:8px;background:#fff;color:#6a7175;padding:7px;font:800 10px system-ui;cursor:pointer}
      .pmvt-selected-remove:hover{border-color:#f58220;color:#d46f17}
      .pmvt-selection-empty{padding:14px;border:1px dashed #d7dcdf;border-radius:10px;color:#657075;font:650 11px/1.5 system-ui}
      .pmvt-selection-actions{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:11px}
      .pmvt-selection-actions .pmvt-action{justify-content:center;min-height:42px;text-align:center}
      .pmvt-selection-actions .pmvt-action:last-child:nth-child(3){grid-column:1/-1}
      .pmvt-action--primary{background:#17191a;border-color:#17191a;color:#fff}
      .pmvt-action--primary:hover{background:#303234;border-color:#303234;color:#fff}
      .pmvt-selection-limit{margin:10px 0 0;color:#667075;font:650 10px/1.5 system-ui}
      .pmvt-document-card{width:100%;margin-top:9px}
      .pmvt-document-card .pmvt-action__icon{width:34px;height:34px;flex-basis:34px}
      .pmvt-document-card>span>strong{font-size:12px}
      .pmvt-document-card>span>small{font-size:10px}

      /* Always reserve the same three vehicle columns. Slot one stays on the left. */
      .pmvt-compare-slot{
        display:flex;flex-direction:column;align-items:center;justify-content:center;
        gap:10px;min-height:167px;padding:17px 11px;
        border:1px dashed #cbd3d7;border-radius:12px;background:#fafbfb;
        color:#667175;text-decoration:none;text-align:center;font:800 11px/1.45 system-ui
      }
      .pmvt-compare-slot:hover{border-color:#f58220;background:#fff8f1;color:#ba5b0b}
      .pmvt-compare-slot__plus{display:grid;place-items:center;width:37px;height:37px;border-radius:50%;background:#fff;border:1px solid #d9dee0;color:#f58220;font:450 29px/1 system-ui}
      .pmvt-compare-slot small{color:#818a8e;font:650 10px/1.3 system-ui}
      .pmvt-compare-notice{margin:14px 0 0;padding:11px 13px;border:1px solid #f3d4b5;border-radius:9px;background:#fff9f1;color:#71410b;font:700 11px/1.45 system-ui}
      .pmvt-compare-mobile-add{display:none}
      .pmvt-empty-data{background:#fcfcfc}
      .pmvt-compare-vehicle{min-height:167px}
      .pmvt-table thead th{vertical-align:top}
      .pmvt-table thead th:not(:first-child){width:calc((100% - 158px)/3)}
      @media(max-width:749px){
        .pmvt-selected-card{grid-template-columns:56px minmax(0,1fr) auto;gap:8px}
        .pmvt-selected-image{width:56px;height:48px}
        .pmvt-selection-actions{grid-template-columns:1fr 1fr}
        .pmvt-compare-mobile-add{display:flex;margin-top:12px;min-height:110px}
      }
      .pmvt-qr{
        display:none;margin-top:10px;padding:12px;border:1px solid #eceeef;
        border-radius:12px;text-align:center;background:#fafafa
      }
      .pmvt-qr.is-open{display:block}
      .pmvt-qr img{display:block;width:180px;height:180px;margin:0 auto 7px;background:#fff}
      .pmvt-qr small{color:#737b80;font:650 9px/1.35 system-ui}

      .pmvt-toast{
        position:fixed;z-index:2147483647;left:50%;bottom:24px;
        transform:translate(-50%,20px);opacity:0;pointer-events:none;
        padding:10px 14px;border-radius:999px;background:#111;color:#fff;
        font:800 11px system-ui;transition:.18s
      }
      .pmvt-toast.is-visible{opacity:1;transform:translate(-50%,0)}

      .pmvt-compare-modal{
        position:fixed;inset:0;z-index:2147482500;background:rgba(7,9,10,.66);
        display:none;align-items:center;justify-content:center;padding:26px
      }
      .pmvt-compare-modal.is-open{display:flex}
      .pmvt-compare-card{
        width:min(1240px,100%);max-height:92vh;overflow:hidden;background:#fff;
        display:flex;flex-direction:column;
        border-radius:20px;border:1px solid #e1e5e7;box-shadow:0 30px 90px rgba(0,0,0,.32)
      }
      .pmvt-compare-top{
        position:relative;z-index:8;flex:0 0 auto;
        display:flex;align-items:center;justify-content:space-between;gap:14px;
        padding:17px 20px;background:#fff;border-bottom:1px solid #eceeef
      }
      .pmvt-compare-top__copy{min-width:0}
      .pmvt-compare-top strong{display:block;font:950 18px/1.15 system-ui;color:#111}
      .pmvt-compare-top small{display:block;margin-top:4px;color:#778085;font:650 10px/1.3 system-ui}
      .pmvt-compare-content{
        flex:1 1 auto;min-height:0;max-height:calc(92vh - 72px);
        overflow:auto;padding:0 20px 22px;overscroll-behavior:contain;
        -webkit-overflow-scrolling:touch
      }

      .pmvt-table{
        width:100%;border-collapse:separate;border-spacing:0;table-layout:fixed;
        font:500 11px/1.35 system-ui;color:#202426
      }
      .pmvt-table th,.pmvt-table td{
        padding:11px 13px;border-bottom:1px solid #eceeef;vertical-align:middle
      }
      .pmvt-table thead th{padding-top:17px;padding-bottom:15px;background:#fff;vertical-align:top}
      .pmvt-table thead th:first-child{width:158px}
      .pmvt-table tbody th{
        width:158px;color:#687176;font-size:9px;font-weight:900;
        text-transform:uppercase;letter-spacing:.045em;text-align:left
      }
      .pmvt-table tbody td{text-align:center;font-weight:800}
      .pmvt-table tbody tr.pmvt-compare-section th{
        padding:16px 13px 8px;border-bottom:2px solid #f58220;background:#fff;
        color:#111;font-size:10px;font-weight:950;letter-spacing:.06em
      }
      .pmvt-table tbody tr.pmvt-compare-section td{
        padding:0;border-bottom:2px solid #f58220;background:#fff
      }
      .pmvt-table tbody tr:not(.pmvt-compare-section):nth-child(even) td,
      .pmvt-table tbody tr:not(.pmvt-compare-section):nth-child(even) th{background:#fafafa}

      .pmvt-compare-vehicle{display:flex;flex-direction:column;align-items:flex-start;gap:6px}
      .pmvt-compare-headimg{
        width:100%;max-width:220px;aspect-ratio:16/10;object-fit:cover;
        border-radius:11px;background:#f1f2f3;border:1px solid #eceeef
      }
      .pmvt-compare-title{
        color:#111!important;text-decoration:none!important;font-size:12px;
        font-weight:950;line-height:1.25
      }
      .pmvt-compare-title:hover{color:#f58220!important}
      .pmvt-compare-price{font-size:15px;font-weight:950;color:#111}
      .pmvt-remove{
        display:inline-flex;align-items:center;justify-content:center;min-height:28px;
        padding:0 9px;border:1px solid #e2e5e7;border-radius:8px;background:#fff;
        color:#8a3a25;font:850 9px system-ui;cursor:pointer
      }
      .pmvt-remove:hover{border-color:#d36a4c;background:#fff7f4}
      .pmvt-empty{padding:36px 12px;color:#687176;text-align:center}
      .pmvt-loading{padding:10px 0 0;color:#7a8286;font:700 9px/1.3 system-ui}

      .pmvt-equipment-cell{text-align:left!important}
      .pmvt-equipment-list{display:flex;flex-wrap:wrap;gap:4px;justify-content:flex-start}
      .pmvt-eq-chip{
        display:inline-flex;align-items:center;min-height:22px;padding:3px 6px;
        border:1px solid #e0e3e5;border-radius:999px;background:#fff;color:#343a3d;
        font:800 8.5px/1.15 system-ui;white-space:normal
      }
      .pmvt-eq-more{color:#f58220;border-color:#f5c89f;background:#fff8f2}

      .pmvt-mobile-compare{display:none}
      .pmvt-mobile-vehicle{
        overflow:hidden;border:1px solid #e2e5e7;border-radius:14px;background:#fff
      }
      .pmvt-mobile-vehicle+.pmvt-mobile-vehicle{margin-top:12px}
      .pmvt-mobile-hero{
        display:grid;grid-template-columns:98px minmax(0,1fr);gap:12px;
        padding:12px;border-bottom:1px solid #eceeef;background:#fff
      }
      .pmvt-mobile-img{
        display:block;width:98px;height:72px;object-fit:cover;border-radius:10px;
        background:#f2f3f3;border:1px solid #eceeef
      }
      .pmvt-mobile-title{
        display:block;color:#111!important;text-decoration:none!important;
        font:950 12px/1.25 system-ui
      }
      .pmvt-mobile-price{margin-top:5px;font:950 16px/1 system-ui;color:#111}
      .pmvt-mobile-remove{margin-top:8px}
      .pmvt-mobile-section{padding:10px 12px 8px}
      .pmvt-mobile-section+.pmvt-mobile-section{border-top:1px solid #eceeef}
      .pmvt-mobile-section h4{
        margin:0 0 7px;color:#f58220;font:950 9px/1.2 system-ui;
        letter-spacing:.07em;text-transform:uppercase
      }
      .pmvt-mobile-quick{
        display:grid;grid-template-columns:1fr 1fr;gap:7px;padding:10px 12px;
        border-bottom:1px solid #eceeef;background:#fafafa
      }
      .pmvt-mobile-quick div{
        min-width:0;padding:8px;border:1px solid #e7e9ea;border-radius:9px;background:#fff
      }
      .pmvt-mobile-quick span{display:block;color:#737c80;font:750 8px/1.2 system-ui}
      .pmvt-mobile-quick strong{display:block;margin-top:3px;color:#111;font:950 10px/1.2 system-ui}
      .pmvt-mobile-row{
        display:grid;grid-template-columns:minmax(0,1fr) auto;gap:12px;align-items:start;
        min-height:31px;padding:7px 0;border-bottom:1px solid #f0f1f2
      }
      .pmvt-mobile-row:last-child{border-bottom:0}
      .pmvt-mobile-row span{color:#6b7478;font:750 9px/1.3 system-ui}
      .pmvt-mobile-row strong{
        max-width:190px;text-align:right;color:#111;font:900 10px/1.3 system-ui;
        overflow-wrap:anywhere
      }
      .pmvt-mobile-equipment{display:flex;flex-wrap:wrap;gap:5px}
      .pmvt-mobile-equipment .pmvt-eq-chip{font-size:8px;min-height:23px}

      /* Transportstyrelsen: alla svar som neutrala tags */
      [data-pmvp-root] .pmvp-registry__row strong{
        display:inline-flex!important;align-items:center!important;justify-content:center!important;
        min-height:24px!important;padding:4px 8px!important;
        border:1px solid #d9dee1!important;border-radius:8px!important;
        background:#fff!important;color:#111!important;font-size:10px!important;
        line-height:1!important;font-weight:850!important;white-space:nowrap!important;
        box-shadow:none!important
      }

      [data-pmvparts] .pmvparts__mobile-total.pmvt-waiting,
      [data-pmvparts] .pmvparts__summary-number.pmvt-waiting{
        visibility:hidden!important
      }

      @media(max-width:749px){
        .pmvt-overlay{align-items:flex-end;justify-content:center;padding:0}
        .pmvt-panel{width:100%;max-height:84vh;border-radius:18px 18px 0 0;border-bottom:0}
        .pmvt-grid{grid-template-columns:1fr 1fr}
        .pmvt-grid--documents{grid-template-columns:1fr 1fr}
        .pmvt-compare-modal{
          align-items:stretch;justify-content:stretch;padding:0;
          height:100dvh;min-height:100dvh
        }
        .pmvt-compare-card{
          width:100%;height:100dvh;max-height:100dvh;
          border-radius:0;border:0;box-shadow:none
        }
        .pmvt-compare-top{
          position:sticky;top:0;z-index:30;
          min-height:64px;
          padding:max(12px,env(safe-area-inset-top)) 14px 12px 16px;
          background:#fff;
          box-shadow:0 2px 10px rgba(0,0,0,.07)
        }
        .pmvt-compare-top .pmvt-close{
          width:42px;height:42px;flex:0 0 42px;
          font-size:24px;border-radius:11px
        }
        .pmvt-compare-content{
          flex:1 1 auto;min-height:0;max-height:none;
          overflow-y:auto;overflow-x:hidden;
          padding:12px 12px calc(18px + env(safe-area-inset-bottom));
          overscroll-behavior:contain;-webkit-overflow-scrolling:touch
        }
        .pmvt-table{display:none}
        .pmvt-mobile-compare{display:block}
        [data-pmvp-root] .pmvp-registry__row strong{
          font-size:9.5px!important;padding:4px 7px!important
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.getElementById('pmvt-style-v20')?.remove();
  injectCss();

  // Remove any UI left by older versions.
  document.querySelectorAll(
    '.pmvt-overlay,.pmvt-compare-modal,.pmvt-compare-pill,.pmvt-more,.pmvt-tool-button'
  ).forEach(el => el.remove());

  function cleanupCustomerUi() {
    const save = $('[data-pmvp-save]');
    if (save) save.remove();

    const share = $('[data-pmvp-copy-link]');
    if (share) share.remove();

    const status = $('.pmvp-registry__status');
    if (status) status.remove();

    const groups = $$('.pmvp-registry__group');

    const wantedOrder = {
      'registrering & historik': [
        'svensksåld',
        'antal ägare',
        'först registrerad',
        'senaste ägarbyte'
      ],
      'skatt & besiktning': [
        'årlig skatt',
        'mätarställning vid besiktning',
        'senast besiktigad',
        'nästa besiktning'
      ]
    };

    groups.forEach(group => {
      const heading = group.querySelector('h3');
      if (!heading) return;

      let title = heading.textContent.trim();

      if (title.toLowerCase() === 'besiktning & skatt') {
        heading.textContent = 'Skatt & besiktning';
        title = 'Skatt & besiktning';
      }

      $$('.pmvp-registry__row', group).forEach(row => {
        const label = row.querySelector('span');
        if (!label) return;

        const text = label.textContent.trim().toLowerCase();

        if (text === 'i trafik i sverige sedan' || text === 'skattemånad') {
          row.remove();
        }
      });

      const order = wantedOrder[title.toLowerCase()];
      if (!order) return;

      const rows = $$('.pmvp-registry__row', group);

      rows.sort((a, b) => {
        const aLabel = (a.querySelector('span')?.textContent || '').trim().toLowerCase();
        const bLabel = (b.querySelector('span')?.textContent || '').trim().toLowerCase();

        const ai = order.indexOf(aLabel);
        const bi = order.indexOf(bLabel);

        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      });

      rows.forEach(row => group.appendChild(row));
    });
  }

  cleanupCustomerUi();

  // Finance preview safety.
  function calcFinancePreview() {
    const out = $('[data-pmvp-hero-monthly]');
    const meta = $('[data-pmvp-hero-meta]');
    if (!out) return;

    const price = Number(root.dataset.priceSek || 0);
    const pct = Math.max(
      Number(root.dataset.financeMinDeposit || 20),
      Number(root.dataset.financeDefaultDeposit || 20),
      20
    );
    const term = Number(root.dataset.financeDefaultTerm || 84);
    const rate = Number(root.dataset.financeRate || 0) / 100 / 12;
    const monthlyFee = Number(root.dataset.financeMonthlyFee || 0);
    const residualPct = Number(root.getAttribute('data-residual-' + term) || 0);

    const deposit = price * pct / 100;
    const loan = Math.max(0, price - deposit);
    const residual = Math.min(loan, Math.max(0, price * residualPct / 100));

    let base = 0;

    if (loan > 0) {
      if (rate <= 0) {
        base = Math.max(0, (loan - residual) / term);
      } else {
        const pvResidual = residual / Math.pow(1 + rate, term);
        const amortizing = Math.max(0, loan - pvResidual);
        const den = 1 - Math.pow(1 + rate, -term);
        base = den > 0 ? amortizing * rate / den : 0;
      }
    }

    const monthly = base + monthlyFee;
    const existing = String(out.textContent || '')
      .replace(/\s*kr(?:\/mån)?\s*$/i, '')
      .trim();

    if (price > 0 && Number.isFinite(monthly)) {
      out.textContent = fmt.format(Math.round(monthly));
    } else if (!existing || existing === '–' || existing === '-' || /nan/i.test(existing)) {
      out.textContent = '–';
    }

    const title = out.closest('.pmvp-buybox__finance-title');
    const caption = title ? title.querySelector(':scope > span') : null;

    if (caption) caption.textContent = 'Exempel på finansiering';
    if (meta) meta.textContent = pct + ' % kontantinsats · ' + term + ' mån';
  }

  calcFinancePreview();
  setTimeout(calcFinancePreview, 250);
  setTimeout(calcFinancePreview, 1000);

  // Related parts: don't show dash while loading.
  function protectPartsPlaceholder() {
    const parts = $('[data-pmvparts]');
    if (!parts) return;

    const wrappers = [
      $('.pmvparts__mobile-total', parts),
      $('.pmvparts__summary-number', parts)
    ].filter(Boolean);

    wrappers.forEach(el => el.classList.add('pmvt-waiting'));

    const refresh = () => {
      const total = $('[data-pmvparts-total]', parts);
      const n = Number(String(total ? total.textContent : '').replace(/[^\d]/g, ''));
      if (n > 0) wrappers.forEach(el => el.classList.remove('pmvt-waiting'));
    };

    refresh();

    new MutationObserver(refresh).observe(parts, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  protectPartsPlaceholder();

  // Similar vehicles: current product must never appear.
  function removeSelfFromSimilar() {
    const holder = $('[data-pmvp-similar]');
    const grid = $('[data-pmvp-similar-grid]');
    if (!holder || !grid) return;

    const currentPath = new URL(product.url || location.href, root.dataset.productUrl || location.href)
      .pathname.replace(/\/$/, '');

    $$('.pmvp-similar-card', grid).forEach(card => {
      const href = card.getAttribute('href') || '';
      let path = '';

      try {
        path = new URL(href, root.dataset.productUrl || location.href).pathname.replace(/\/$/, '');
      } catch (_) {}

      if (
        path === currentPath ||
        (product.handle && path.endsWith('/products/' + product.handle))
      ) {
        card.remove();
      }
    });

    if (!grid.querySelector('.pmvp-similar-card')) holder.hidden = true;
  }

  const simGrid = $('[data-pmvp-similar-grid]');

  if (simGrid) {
    removeSelfFromSimilar();
    new MutationObserver(removeSelfFromSimilar).observe(simGrid, {
      childList: true,
      subtree: true
    });
  }

  function factMap() {
    const map = {};

    $$('.pmvp__facts-table > div, .pmvp-buybox__spec').forEach(row => {
      const label = row.querySelector('span');
      const value = row.querySelector('strong');

      if (!label || !value) return;

      const key = label.textContent.trim().toLowerCase();

      if (key && !map[key]) {
        map[key] = value.textContent.trim();
      }
    });

    return map;
  }

  function equipment() {
    return $$('.pmvp__equipment span')
      .map(el => el.textContent.trim())
      .filter(Boolean);
  }

  function registryGroups() {
    return $$('.pmvp-registry__group')
      .map(group => {
        const h = group.querySelector('h3');

        const rows = $$('.pmvp-registry__row', group)
          .map(row => {
            const s = row.querySelector('span');
            const v = row.querySelector('strong');
            return s && v ? [s.textContent.trim(), v.textContent.trim()] : null;
          })
          .filter(Boolean);

        return {
          title: h ? h.textContent.trim() : '',
          rows
        };
      })
      .filter(g => g.rows.length);
  }

  function dealer() {
    const area = $('.pmvp__dealer-section');
    const tel = area ? area.querySelector('a[href^="tel:"]') : null;
    const mail = area ? area.querySelector('a[href^="mailto:"]') : null;
    const address = area ? area.querySelector('p') : null;

    return {
      phone: tel ? tel.textContent.trim() : '',
      email: mail ? mail.textContent.trim() : '',
      address: address ? address.textContent.trim() : ''
    };
  }

  function normalizeCompareLabel(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function factsMapFromDocument(doc) {
    const map = {};

    Array.from(doc.querySelectorAll('.pmvp__facts-table > div, .pmvp-buybox__spec')).forEach(row => {
      const label = row.querySelector('span');
      const value = row.querySelector('strong');
      if (!label || !value) return;

      const key = normalizeCompareLabel(label.textContent);
      const val = value.textContent.trim();
      if (key && val && !map[key]) map[key] = val;
    });

    return map;
  }

  function registryMapFromDocument(doc) {
    const map = {};

    Array.from(doc.querySelectorAll('.pmvp-registry__row')).forEach(row => {
      const label = row.querySelector('span');
      const value = row.querySelector('strong');
      if (!label || !value) return;

      const key = normalizeCompareLabel(label.textContent);
      const val = value.textContent.trim();
      if (key && val && !map[key]) map[key] = val;
    });

    return map;
  }

  function equipmentFromDocument(doc) {
    const seen = new Set();

    return Array.from(doc.querySelectorAll('.pmvp__equipment span'))
      .map(el => el.textContent.trim())
      .filter(value => {
        if (!value || value.length > 90) return false;
        const key = value.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function buildCompareSnapshotFromDocument(doc, fallback = {}) {
    const compareRoot = doc.querySelector('[data-pmvp-root]');
    const data = compareRoot ? compareRoot.dataset : {};
    const facts = factsMapFromDocument(doc);
    const registry = registryMapFromDocument(doc);
    const equipmentList = equipmentFromDocument(doc);

    const title = String(data.productTitle || fallback.title || '').trim();
    const brand = String(data.brand || facts.märke || fallback.brand || '').trim();
    const year = String(data.modelYear || facts.årsmodell || fallback.year || '').trim();

    let model = String(facts.modell || fallback.model || '').trim();

    if (!model && title) {
      model = title;

      if (brand) {
        const safeBrand = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        model = model.replace(new RegExp('^' + safeBrand + '\\s*', 'i'), '');
      }

      if (year) {
        const safeYear = year.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        model = model.replace(new RegExp('\\s*' + safeYear + '\\s*$', 'i'), '');
      }

      model = model.trim();
    }

    const rawPrice = Number(data.priceSek || 0);

    return {
      ...fallback,
      id: String(data.productId || fallback.id || data.productHandle || fallback.url || ''),
      handle: String(data.productHandle || fallback.handle || ''),
      title: title || fallback.title || '',
      url: String(data.productUrl || fallback.url || ''),
      image: String(data.productImage || fallback.image || ''),
      price: rawPrice > 0 ? money(rawPrice) : (fallback.price || ''),
      brand,
      model,
      year,
      mileage: facts.miltal || fallback.mileage || '',
      engine: facts.motorvolym || fallback.engine || '',
      power: facts.effekt || fallback.power || '',
      fuel: facts.drivmedel || fallback.fuel || '',
      type: facts.typ || fallback.type || '',
      color: facts.färg || fallback.color || '',
      gearbox: facts.växellåda || fallback.gearbox || '',
      reg: String(data.reg || facts.regnr || fallback.reg || '').trim(),
      vin: String(data.vin || facts.vin || fallback.vin || '').trim(),

      swedishSold: registry['svensksåld'] || fallback.swedishSold || '',
      owners: registry['antal ägare'] || fallback.owners || '',
      firstRegistered: registry['först registrerad'] || fallback.firstRegistered || '',
      latestOwnerChange: registry['senaste ägarbyte'] || fallback.latestOwnerChange || '',

      annualTax: registry['årlig skatt'] || fallback.annualTax || '',
      lastInspection: registry['senast besiktigad'] || fallback.lastInspection || '',
      inspectionMileage: registry['mätarställning vid besiktning'] || fallback.inspectionMileage || '',
      nextInspection: registry['nästa besiktning'] || fallback.nextInspection || '',

      serviceWeight: registry['tjänstevikt'] || fallback.serviceWeight || '',
      totalWeight: registry['totalvikt'] || fallback.totalWeight || '',
      frontTire: registry['däck fram'] || fallback.frontTire || '',
      rearTire: registry['däck bak'] || fallback.rearTire || '',

      equipment: equipmentList.length
        ? equipmentList
        : (Array.isArray(fallback.equipment) ? fallback.equipment : []),

      compareDataVersion: 28
    };
  }

  function snapshot() {
    return buildCompareSnapshotFromDocument(document, {
      id: product.id || product.handle || product.url,
      title: product.title,
      url: product.url || location.href,
      image: product.image,
      price: money(product.price),
      reg: product.reg || '',
      year: product.year || ''
    });
  }

  // Compare storage.
  const COMPARE_KEY = 'pm_vehicle_compare_v1';

  function getCompare() {
    try {
      const list = JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
      return Array.isArray(list) ? list.slice(0, 3) : [];
    } catch (_) {
      return [];
    }
  }

  function setCompare(list) {
    try {
      localStorage.setItem(COMPARE_KEY, JSON.stringify(list.slice(0, 3)));
    } catch (_) {}

    updateCompareButton();
    if (overlay && overlay.classList.contains('is-open')) renderPanelCompare();
  }

  function isCurrentCompared() {
    const id = snapshot().id;
    return getCompare().some(x => String(x.id) === String(id));
  }

  function addCurrentToCompare() {
    const item = snapshot();
    let list = getCompare();

    const existingIndex = list.findIndex(
      x => String(x.id) === String(item.id)
    );

    if (existingIndex !== -1) {
      list[existingIndex] = {
        ...list[existingIndex],
        ...item
      };
      setCompare(list);
      return true;
    }

    if (list.length >= 3) {
      toast('Du kan jämföra högst 3 fordon');
      return false;
    }

    list.push(item);
    setCompare(list);
    return true;
  }

  function compareNeedsEnrichment(item) {
    return !item ||
      Number(item.compareDataVersion || 0) < 28 ||
      !Array.isArray(item.equipment);
  }

  async function enrichCompareItem(item) {
    if (!item || !item.url || !compareNeedsEnrichment(item)) return item;

    try {
      const targetUrl = new URL(item.url, location.origin);
      if (targetUrl.origin !== location.origin) return item;

      const response = await fetch(targetUrl.href, {
        credentials: 'same-origin'
      });

      if (!response.ok) return item;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return buildCompareSnapshotFromDocument(doc, item);
    } catch (_) {
      return item;
    }
  }

  async function enrichCompareList() {
    const before = getCompare();
    if (!before.length) return before;

    const enriched = await Promise.all(
      before.map(item => enrichCompareItem(item))
    );

    const updatedById = new Map(enriched.map(item => [String(item.id), item]));
    const stillSelected = getCompare().map(item =>
      updatedById.get(String(item.id)) || item
    );
    setCompare(stillSelected);
    return stillSelected;
  }

  let compareModal = null;
  let comparePrevHtmlOverflow = '';
  let comparePrevBodyOverflow = '';

  function compareValue(item, key) {
    const value = item && item[key] != null ? String(item[key]).trim() : '';
    return value || '–';
  }

  function compareRow(label, key, list) {
    const hasAny = list.some(item => compareValue(item, key) !== '–');
    if (!hasAny) return '';

    return '<tr><th>' + esc(label) + '</th>' +
      list.map(item => item
        ? '<td>' + esc(compareValue(item, key)) + '</td>'
        : '<td class="pmvt-empty-data"></td>').join('') +
      '</tr>';
  }

  function compareSection(title, list) {
    return '<tr class="pmvt-compare-section">' +
      '<th>' + esc(title) + '</th>' +
      list.map(() => '<td></td>').join('') +
      '</tr>';
  }

  function equipmentChips(item, limit = 10) {
    const values = Array.isArray(item && item.equipment)
      ? item.equipment.filter(Boolean)
      : [];

    if (!values.length) return '–';

    const visible = values.slice(0, limit);
    const rest = Math.max(0, values.length - visible.length);

    return '<div class="pmvt-equipment-list">' +
      visible.map(value => '<span class="pmvt-eq-chip">' + esc(value) + '</span>').join('') +
      (rest ? '<span class="pmvt-eq-chip pmvt-eq-more">+' + rest + '</span>' : '') +
      '</div>';
  }

  function compareEquipmentRow(list) {
    const hasAny = list.some(item => item && Array.isArray(item.equipment) && item.equipment.length);
    if (!hasAny) return '';

    return '<tr class="pmvt-equipment-row">' +
      '<th>Utrustning</th>' +
      list.map(item => item
        ? '<td class="pmvt-equipment-cell">' + equipmentChips(item, 10) + '</td>'
        : '<td class="pmvt-empty-data"></td>').join('') +
      '</tr>';
  }

  const compareGroups = [
    {
      title: 'Fakta',
      rows: [
        ['Märke', 'brand'],
        ['Modell', 'model'],
        ['Årsmodell', 'year'],
        ['Miltal', 'mileage'],
        ['Motor', 'engine'],
        ['Effekt', 'power'],
        ['Drivmedel', 'fuel'],
        ['Typ', 'type'],
        ['Färg', 'color'],
        ['Växellåda', 'gearbox'],
        ['Regnr', 'reg']
      ]
    },
    {
      title: 'Historik',
      rows: [
        ['Svensksåld', 'swedishSold'],
        ['Antal ägare', 'owners'],
        ['Först registrerad', 'firstRegistered'],
        ['Senaste ägarbyte', 'latestOwnerChange']
      ]
    },
    {
      title: 'Skatt & besiktning',
      rows: [
        ['Årlig skatt', 'annualTax'],
        ['Senast besiktigad', 'lastInspection'],
        ['Miltal vid besiktning', 'inspectionMileage'],
        ['Nästa besiktning', 'nextInspection']
      ]
    },
    {
      title: 'Vikt & teknik',
      rows: [
        ['Tjänstevikt', 'serviceWeight'],
        ['Totalvikt', 'totalWeight'],
        ['Däck fram', 'frontTire'],
        ['Däck bak', 'rearTire']
      ]
    }
  ];

  function openCompare() {
    if (!compareModal) {
      compareModal = document.createElement('div');
      compareModal.className = 'pmvt-compare-modal';

      compareModal.innerHTML =
        '<div class="pmvt-compare-card" role="dialog" aria-modal="true">' +
          '<div class="pmvt-compare-top">' +
            '<div class="pmvt-compare-top__copy">' +
              '<strong>Jämför fordon</strong>' +
              '<small data-pmvt-compare-subtitle></small>' +
            '</div>' +
            '<button class="pmvt-close" data-pmvt-compare-close aria-label="Stäng">×</button>' +
          '</div>' +
          '<div class="pmvt-compare-content" data-pmvt-compare-content></div>' +
        '</div>';

      document.body.appendChild(compareModal);

      compareModal.addEventListener('click', e => {
        if (
          e.target === compareModal ||
          e.target.closest('[data-pmvt-compare-close]')
        ) {
          closeCompare();
          return;
        }

        const rem = e.target.closest('[data-pmvt-remove]');

        if (rem) {
          const next = getCompare().filter(
            item => String(item.id) !== String(rem.dataset.pmvtRemove)
          );

          setCompare(next);
          renderCompare();
        }
      });
    }

    renderCompare();
    compareModal.classList.add('is-open');

    comparePrevHtmlOverflow = document.documentElement.style.overflow || '';
    comparePrevBodyOverflow = document.body.style.overflow || '';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    const compareContent = compareModal.querySelector('[data-pmvt-compare-content]');
    if (compareContent) compareContent.scrollTop = 0;

    enrichCompareList().then(() => {
      if (compareModal && compareModal.classList.contains('is-open')) {
        renderCompare();
      }
    });
  }

  function mobileCompareRows(item, group) {
    const rows = group.rows
      .filter(([_, key]) => compareValue(item, key) !== '–')
      .map(([label, key]) =>
        '<div class="pmvt-mobile-row">' +
          '<span>' + esc(label) + '</span>' +
          '<strong>' + esc(compareValue(item, key)) + '</strong>' +
        '</div>'
      )
      .join('');

    if (!rows) return '';

    return '<section class="pmvt-mobile-section">' +
      '<h4>' + esc(group.title) + '</h4>' +
      rows +
    '</section>';
  }

  function renderMobileCompare(list) {
    return '<div class="pmvt-mobile-compare">' +
      list.map(item => {
        const quick = [
          ['Årsmodell', 'year'],
          ['Miltal', 'mileage'],
          ['Motor', 'engine'],
          ['Effekt', 'power']
        ].filter(([_, key]) => compareValue(item, key) !== '–');

        const quickHtml = quick.length
          ? '<div class="pmvt-mobile-quick">' +
              quick.map(([label, key]) =>
                '<div><span>' + esc(label) + '</span><strong>' +
                  esc(compareValue(item, key)) + '</strong></div>'
              ).join('') +
            '</div>'
          : '';

        const equipmentHtml = Array.isArray(item.equipment) && item.equipment.length
          ? '<section class="pmvt-mobile-section">' +
              '<h4>Utrustning</h4>' +
              '<div class="pmvt-mobile-equipment">' +
                item.equipment.slice(0, 14).map(value =>
                  '<span class="pmvt-eq-chip">' + esc(value) + '</span>'
                ).join('') +
                (item.equipment.length > 14
                  ? '<span class="pmvt-eq-chip pmvt-eq-more">+' + (item.equipment.length - 14) + '</span>'
                  : '') +
              '</div>' +
            '</section>'
          : '';

        return '<article class="pmvt-mobile-vehicle">' +
          '<div class="pmvt-mobile-hero">' +
            (item.image
              ? '<img class="pmvt-mobile-img" src="' + esc(item.image) + '" alt="">'
              : '<div class="pmvt-mobile-img"></div>') +
            '<div>' +
              '<a class="pmvt-mobile-title" href="' + esc(item.url || '#') + '">' +
                esc(item.title || 'Fordon') +
              '</a>' +
              '<div class="pmvt-mobile-price">' + esc(item.price || '') + '</div>' +
              '<button class="pmvt-remove pmvt-mobile-remove" data-pmvt-remove="' +
                esc(item.id) + '">Ta bort</button>' +
            '</div>' +
          '</div>' +
          quickHtml +
          equipmentHtml +
          compareGroups.slice(1).map(group => mobileCompareRows(item, group)).join('') +
        '</article>';
      }).join('') +
      (list.length < 3
        ? '<a class="pmvt-compare-slot pmvt-compare-mobile-add" href="' + esc(collectionReturnUrl()) + '">' +
            '<span class="pmvt-compare-slot__plus" aria-hidden="true">+</span>' +
            '<strong>Lägg till fordon</strong>' +
            '<small>Välj nästa motorcykel</small>' +
          '</a>'
        : '') +
    '</div>';
  }

  function renderCompare() {
    if (!compareModal) return;

    const list = getCompare();
    const slots = [list[0] || null, list[1] || null, list[2] || null];
    const content = compareModal.querySelector('[data-pmvt-compare-content]');
    const subtitle = compareModal.querySelector('[data-pmvt-compare-subtitle]');
    const currentOutsideFullList = list.length === 3 && !isCurrentCompared();

    if (subtitle) {
      subtitle.textContent = list.length + ' av 3 fordon valda · fakta, utrustning, historik och teknik';
    }

    if (!list.length) {
      content.innerHTML =
        '<div class="pmvt-empty">Inga fordon valda ännu.</div>' +
        '<a class="pmvt-compare-slot" href="' + esc(collectionReturnUrl()) + '">' +
          '<span class="pmvt-compare-slot__plus" aria-hidden="true">+</span>' +
          '<strong>Hitta fordon att jämföra</strong>' +
        '</a>';
      return;
    }

    const head = slots.map((item, index) => {
      if (!item) {
        return '<th><a class="pmvt-compare-slot" href="' + esc(collectionReturnUrl()) + '">' +
          '<span class="pmvt-compare-slot__plus" aria-hidden="true">+</span>' +
          '<strong>Lägg till fordon</strong>' +
          '<small>Plats ' + (index + 1) + ' av 3</small>' +
        '</a></th>';
      }

      return '<th>' +
        '<div class="pmvt-compare-vehicle">' +
          (item.image
            ? '<img class="pmvt-compare-headimg" src="' + esc(item.image) + '" alt="">'
            : '') +
          '<a class="pmvt-compare-title" href="' + esc(item.url || '#') + '">' +
            esc(item.title || 'Fordon') +
          '</a>' +
          '<div class="pmvt-compare-price">' + esc(item.price || '') + '</div>' +
          '<button type="button" class="pmvt-remove" data-pmvt-remove="' + esc(item.id) + '">Ta bort</button>' +
        '</div>' +
      '</th>';
    }).join('');

    let body = '';
    compareGroups.forEach((group, index) => {
      const rows = group.rows
        .map(([label, key]) => compareRow(label, key, slots))
        .join('');

      if (!rows) return;
      body += compareSection(group.title, slots) + rows;
      if (index === 0) body += compareEquipmentRow(slots);
    });

    content.innerHTML =
      (currentOutsideFullList
        ? '<div class="pmvt-compare-notice">Tre fordon är redan valda. Ta bort ett för att kunna lägga till det här fordonet.</div>'
        : '') +
      '<table class="pmvt-table">' +
        '<thead><tr><th>FORDON</th>' + head + '</tr></thead>' +
        '<tbody>' + body + '</tbody>' +
      '</table>' +
      renderMobileCompare(list) +
      (list.some(compareNeedsEnrichment)
        ? '<div class="pmvt-loading">Hämtar kompletterande fordonsuppgifter…</div>'
        : '');
  }

  function closeCompare() {
    if (compareModal) compareModal.classList.remove('is-open');

    document.documentElement.style.overflow = comparePrevHtmlOverflow;
    document.body.style.overflow = comparePrevBodyOverflow;
  }

  function updateCompareButton() {
    const btn = $('[data-pmvt-compare]');
    if (!btn) return;

    const count = getCompare().length;
    const badge = btn.querySelector('[data-pmvt-compare-count]');
    const alreadyAdded = isCurrentCompared();

    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    btn.setAttribute('aria-label', alreadyAdded
      ? 'Öppna jämförelsen, ' + count + ' fordon valda'
      : 'Jämför fordon' + (count ? ', ' + count + ' fordon valda' : ''));
    btn.title = alreadyAdded || count === 3
      ? 'Öppna jämförelsen'
      : 'Lägg till fordonet och jämför';
  }

  // Printable vehicle sheet.
  function printVehicleSheet() {
    const facts = factMap();
    const equip = equipment();
    const d = dealer();
    const destination = new URL(product.url || location.href, location.origin);
    destination.search = '';
    destination.hash = '';
    const pageUrl = destination.href;
    const qr = 'https://quickchart.io/qr?format=svg&size=1024&margin=4&ecLevel=H&dark=000000&light=ffffff&text=' + encodeURIComponent(pageUrl);
    const logoUrl = 'https://cdn.shopify.com/s/files/1/0868/1376/9994/files/logo-light-bg_974bb034-4dda-47f7-9e01-fad5ac2a14f7.svg?v=1773258549';
    const title = product.title || 'Fordon';
    const year = facts.årsmodell || product.year || '';
    const reg = product.reg || facts.regnr || '';
    const brand = facts.märke || product.brand || '';
    let model = facts.modell || '';
    if (!model && title) {
      model = title;
      if (brand) model = model.replace(new RegExp('^' + brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'i'), '');
      if (year) model = model.replace(new RegExp('\\s*' + String(year).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$', 'i'), '');
      model = model.trim();
    }
    const description = ($('.pmvp__description')?.innerText || '').replace(/\r\n?/g, '\n').replace(/[^\S\n]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n').trim();
    const descriptionHtml = description.split(/\n\s*\n/).filter(Boolean).map(paragraph => '<p>' + esc(paragraph).replace(/\n/g, '<br>') + '</p>').join('');
    const monthlyText = $('[data-pmvp-hero-monthly]')?.textContent.trim().replace(/\s*kr(?:\/mån)?\s*$/i, '') || '';
    const financeMeta = $('[data-pmvp-hero-meta]')?.textContent.trim() || '';
    const depositPct = Math.max(Number(root.dataset.financeMinDeposit || 20), Number(root.dataset.financeDefaultDeposit || 20), 20);
    const depositSek = product.price > 0 ? Math.round(product.price * depositPct / 100) : 0;
    const financeRate = Number(root.dataset.financeRate || 0);
    const hasFinance = !!monthlyText && /\d/.test(monthlyText) && !/nan/i.test(monthlyText);
    const topFacts = [year, facts.miltal, facts.motorvolym, facts.effekt].filter(Boolean).join(' · ');
    const specHtml = [
      ['Märke', brand], ['Modell', model], ['Årsmodell', year], ['Miltal', facts.miltal],
      ['Motorvolym', facts.motorvolym], ['Effekt', facts.effekt], ['Drivmedel', facts.drivmedel],
      ['Växellåda', facts.växellåda], ['Färg', facts.färg], ['Reg.nr', reg], ['VIN', product.vin || facts.vin]
    ].filter(row => row[1]).map(([label, value]) => '<div class="kv"><span>' + esc(label) + '</span><strong>' + esc(value) + '</strong></div>').join('');
    const equipmentHtml = equip.map(item => '<li><b aria-hidden="true">✓</b><span>' + esc(item) + '</span></li>').join('');
    const contactLine = [d.phone, d.email].filter(Boolean).join(' · ');
    const financeHtml = hasFinance ? `<section class="finance-card">
      <div class="eyebrow">FINANSIERINGSEXEMPEL</div>
      <div class="monthly"><strong>${esc(monthlyText)}</strong><span>kr/mån</span></div>
      <div class="finance-terms">${esc(financeMeta || depositPct + ' % kontantinsats')}</div>
      <div class="finance-detail">Kontantinsats ${esc(money(depositSek))}${financeRate ? ' · Ränta ' + esc(String(financeRate).replace('.', ',')) + ' %' : ''}</div>
    </section>` : '';
    const warningHtml = hasFinance ? `<div class="credit-warning"><strong>Att låna kostar pengar.</strong> Om du inte kan betala tillbaka skulden i tid riskerar du en betalningsanmärkning. Det kan leda till svårigheter att få hyra bostad, teckna abonnemang och få nya lån. För stöd, vänd dig till budget- och skuldrådgivningen i din kommun. Kontaktuppgifter finns på konsumentverket.se.</div>` : '';
    const html = `<!doctype html>
  <html lang="sv"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
  <title>${esc(String(reg || 'fordonsblad').toUpperCase())}</title>
  <style>
  *{box-sizing:border-box}
  :root{--orange:#f58220;--ink:#000;--muted:#222;--line:#d9dfe2;--green:#176640;color-scheme:light}
  html,body{margin:0;padding:0;background:#e9ecec;color:var(--ink);font-family:Arial,Helvetica,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .toolbar{position:sticky;top:0;z-index:10;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;gap:10px;padding:12px;background:#151c22;color:#fff;font-size:14px}
  .toolbar button{min-height:44px;padding:10px 18px;border:0;border-radius:8px;background:var(--orange);color:#fff;font:700 15px Arial;cursor:pointer}
  .toolbar button:disabled{opacity:.65;cursor:wait}
  .toolbar p{margin:0;max-width:600px;line-height:1.4}
  [hidden]{display:none!important}
  .preview-page{width:210mm;max-width:100%;margin:18px auto;background:#fff;box-shadow:0 8px 36px #0002;overflow:hidden}
  .sheet{width:210mm;min-height:296mm;padding:8mm;background:#fff;transform-origin:top left}
  .sheet-content{display:flex;flex-direction:column;gap:3mm;min-height:280mm}
  .sheet-content>*{flex-shrink:0}
  .top{display:grid;grid-template-columns:minmax(0,1fr) 29mm;gap:5mm;align-items:start;break-inside:avoid;margin-bottom:3mm}
  .title{margin:0;font-size:22pt;line-height:1.08;letter-spacing:-.025em;font-weight:900;overflow-wrap:anywhere}
  .top-facts{margin-top:2.5mm;font-size:12pt;line-height:1.3;font-weight:700}
  .logo{display:block;width:29mm;max-height:23mm;object-fit:contain;object-position:right top}
  .description{margin:0;font-size:11.5pt;line-height:1.34;orphans:3;widows:3}
  .two-col{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.2fr);gap:6mm;align-items:start;break-inside:avoid;margin-top:3mm}
  .card{min-width:0;padding:0}
  .card-title{margin:0 0 2mm;padding-bottom:1.5mm;border-bottom:2px solid var(--orange);font-size:13pt;line-height:1.2;font-weight:800}
  .kv{display:grid;grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr);gap:2mm;padding:.8mm 0;border-bottom:1px solid #e5e8ea;font-size:11.5pt;line-height:1.2}
  .kv:last-child{border:0}
  .kv>span{color:#000;font-size:11.5pt}
  .kv>strong{text-align:right;font-weight:700;overflow-wrap:anywhere}
  .equipment{display:grid;grid-template-columns:1fr;gap:1.5mm;margin:0;padding:0;list-style:none}
  .equipment li{display:flex;gap:1.5mm;font-size:11.5pt;line-height:1.25;break-inside:avoid}
  .equipment li b{color:var(--orange);flex:0 0 auto;font-weight:800}
  .equipment--dense{grid-template-columns:repeat(2,minmax(0,1fr));column-gap:2.5mm}
  .qr-card{display:grid;grid-template-columns:34mm minmax(0,1fr);gap:3mm;align-items:center;padding:0;background:#fff;break-inside:avoid}
  .qr-code{position:relative;width:34mm;height:34mm;background:#fff!important;color:#000!important;opacity:1!important;filter:none!important;mix-blend-mode:normal!important}
  .qr-image{display:block;width:34mm;height:34mm;max-width:none;background:#fff!important;opacity:1!important;filter:none!important;mix-blend-mode:normal!important;image-rendering:pixelated;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
  .qr-card strong{display:block;font-size:11pt;line-height:1.25}
  .qr-card p{margin:1.5mm 0 0;font-size:9.5pt;line-height:1.3;color:#222;overflow-wrap:anywhere}
  .qr-card a{color:#000;text-decoration:none}
  .commerce{display:grid;grid-template-columns:minmax(0,1fr);gap:0;align-items:stretch;width:80mm;max-width:100%;justify-self:end;break-inside:avoid;border:1px solid #dfdfdb;border-top:2px solid var(--orange);border-radius:2mm;overflow:hidden}
  .commerce--single{grid-template-columns:1fr}
  .cash-card,.finance-card{padding:1.5mm 4mm;background:#faf9f6;min-width:0}
  .cash-card{display:block;text-align:right}
  .eyebrow{font-size:9.5pt;font-weight:800;line-height:1.3}
  .cash-price{display:block;margin:1mm 0 0;color:var(--orange);font-size:28pt;line-height:1;letter-spacing:-.04em;font-weight:900;white-space:nowrap;text-align:right}
  .cash-note{grid-column:2;grid-row:1;font-size:9pt;color:#555;text-align:right}
  .finance-card{display:grid;grid-template-columns:auto minmax(0,1fr);gap:1mm 4mm;align-items:center;border-top:1px solid #d9dfda;background:#edf5ef;color:var(--green)}
  .monthly{display:flex;grid-column:1/-1;grid-row:2;flex-wrap:wrap;gap:2mm;align-items:baseline;justify-content:flex-end;margin:0}
  .monthly>strong{font-size:19pt;line-height:1;letter-spacing:-.04em;font-weight:900}
  .monthly>span{font-size:10pt;font-weight:700}
  .finance-terms{grid-column:1/-1;grid-row:3;font-size:9pt;line-height:1.3;font-weight:700;text-align:right}
  .finance-detail{grid-column:1/-1;grid-row:4;margin:0;font-size:8.5pt;line-height:1.3;text-align:right}
  .credit-warning{font-size:8.5pt;line-height:1.3;color:#333;break-inside:avoid}
  .footer{display:flex;justify-content:space-between;flex-wrap:wrap;gap:1.5mm 4mm;border-top:1px solid var(--line);padding-top:2mm;font-size:11pt;line-height:1.3;break-inside:avoid}
  .footer strong,.footer .contact{font-weight:700}
  .description p{margin:0 0 2.8mm}
  .description p:last-child{margin-bottom:0}
  .bottom-row{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:5mm;align-items:center;margin-top:auto;padding-top:1mm;break-inside:avoid}
  .qr-bolt{position:absolute;left:50%;top:50%;width:4.5mm;height:9mm;transform:translate(-50%,-50%);pointer-events:none}
  .qr-bolt svg{display:block;width:100%;height:100%;overflow:visible}
  .qr-bolt path{stroke:#fff;stroke-width:3;stroke-linejoin:round;paint-order:stroke fill}
  .finance-card .eyebrow{grid-column:1/-1;grid-row:1;font-size:8.5pt;text-align:right}
  @page{size:A4 portrait;margin:8mm}
  @media print{
    html,body{width:auto;background:#fff;margin:0!important;padding:0!important}
    .toolbar{display:none!important}
    .preview-page{width:auto;max-width:none;height:auto!important;margin:0;overflow:visible;box-shadow:none}
    .sheet{width:auto;min-height:0;padding:0;transform:none!important}
    .sheet-content{min-height:279mm}
    .qr-code,.qr-image{opacity:1!important;filter:none!important;background:#fff!important}
  }
  @media screen and (max-width:820px){.preview-page{margin:0;box-shadow:none}}
  </style></head><body>
  <div class="toolbar"><button id="print-sheet" type="button" disabled>Laddar QR-kod...</button><p id="sheet-status" role="status" hidden></p><button id="retry-qr" type="button" hidden>Försök igen</button></div>
  <main class="preview-page"><article class="sheet"><div class="sheet-content">
  <header class="top"><div><h1 class="title">${esc(title)}</h1>${topFacts ? '<div class="top-facts">' + esc(topFacts) + '</div>' : ''}</div><img class="logo" src="${logoUrl}" alt="Pauls Motor"></header>
  ${descriptionHtml ? '<div class="description">' + descriptionHtml + '</div>' : ''}
  <div class="two-col"><section class="card"><h2 class="card-title">Specifikationer</h2>${specHtml}</section>
  <section class="card"><h2 class="card-title">Utrustning & övrig info</h2>${equipmentHtml ? '<ul class="equipment' + (equip.length > 12 ? ' equipment--dense' : '') + '">' + equipmentHtml + '</ul>' : '<p class="description">Skanna QR-koden för fullständig information.</p>'}</section></div>

  <div class="bottom-row"><div class="qr-card"><div class="qr-code"><img class="qr-image" src="${qr}" alt="QR-kod till fordonsannonsen"><span class="qr-bolt" aria-hidden="true"><svg viewBox="2 0 16 32" xmlns="http://www.w3.org/2000/svg"><path fill="#f58220" d="M12 0 2 18h8L8 32 18 14h-8z"/></svg></span></div><div><strong><a href="${esc(pageUrl)}">Se hela annonsen</a></strong><p>Skanna för fler bilder.</p><p>${esc(d.address)}</p></div></div><div class="commerce${hasFinance ? '' : ' commerce--single'}"><section class="cash-card"><div class="eyebrow">KONTANTPRIS</div><strong class="cash-price">${esc(money(product.price))}</strong></section>${financeHtml}</div></div>
  ${warningHtml}
  <footer class="footer"><strong>Pauls Motor</strong>${contactLine ? '<span class="contact">' + esc(contactLine) + '</span>' : ''}</footer>
  </div></article></main>
  <script>
  const printButton=document.getElementById('print-sheet');
  const qrImage=document.querySelector('.qr-image');
  const status=document.getElementById('sheet-status');
  const retry=document.getElementById('retry-qr');
  function fitSheet(){
    const sheet=document.querySelector('.sheet');
    const preview=document.querySelector('.preview-page');
    sheet.style.transform='none';
    const rect=sheet.getBoundingClientRect();
    const scale=Math.min(1,preview.getBoundingClientRect().width/rect.width);
    sheet.style.transform='scale('+scale+')';
    preview.style.height=rect.height*scale+'px';
    document.body.dataset.fitScale='1';
    document.body.dataset.previewScale=String(scale);
  }
  window.addEventListener('beforeprint',fitSheet);
  window.addEventListener('resize',fitSheet);
  window.addEventListener('afterprint',fitSheet);
  function loadImage(image){
    return new Promise(resolve=>{
      if(image.complete){resolve(image.naturalWidth>0);return;}
      const done=()=>{clearTimeout(timer);image.removeEventListener('load',done);image.removeEventListener('error',done);resolve(image.naturalWidth>0);};
      const timer=setTimeout(done,15000);
      image.addEventListener('load',done,{once:true});
      image.addEventListener('error',done,{once:true});
    });
  }
  async function prepareSheet(){
    printButton.disabled=true;
    printButton.textContent='Laddar QR-kod...';
    status.hidden=true;
    retry.hidden=true;
    const results=await Promise.all([loadImage(qrImage),...Array.from(document.images).filter(image=>image!==qrImage).map(loadImage),document.fonts?document.fonts.ready:Promise.resolve()]);
    fitSheet();
    if(results[0]){
      printButton.disabled=false;
      printButton.textContent='Skriv ut / Spara som PDF';
      document.body.dataset.sheetReady='true';
    }else{
      printButton.textContent='QR-koden kunde inte laddas';
      status.textContent='Kontrollera anslutningen och försök igen innan du skriver ut.';
      status.hidden=false;
      retry.hidden=false;
      document.body.dataset.sheetReady='error';
    }
  }
  retry.addEventListener('click',()=>{const url=new URL(qrImage.src);url.searchParams.set('retry',String(Date.now()));qrImage.src=url.href;prepareSheet();});
  printButton.addEventListener('click',()=>{if(document.body.dataset.sheetReady==='true')window.print();});
  fitSheet();
  prepareSheet();
  <\/script>
  </body></html>`;
    const win = window.open('', '_blank', 'popup=yes,width=940,height=980');
    if (!win) { toast('Tillåt popup-fönster för fordonsblad'); return; }
    try {
      win.document.open();
      win.document.write(html);
      win.document.close();
      win.opener = null;
      const safeReg = String(reg || 'fordonsblad').toUpperCase().replace(/[^A-Z0-9_-]+/g, '-');
      win.document.title = safeReg;
      try { win.history.replaceState({}, '', '/fordonsblad/' + safeReg); } catch (error) {}
    } catch (error) {
      try { win.close(); } catch (closeError) {}
      toast('Kunde inte skapa fordonsbladet');
    }
  }

  function shareUrl(kind) {
    const url = encodeURIComponent(product.url || location.href);
    const title = encodeURIComponent(product.title);
    const text = encodeURIComponent(
      product.title + ' – ' + money(product.price)
    );

    const targets = {
      whatsapp: 'https://wa.me/?text=' + text + '%20' + url,
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + url,
      email: 'mailto:?subject=' + title + '&body=' + text + '%0A%0A' + url,
      sms: 'sms:?&body=' + text + '%20' + url
    };

    if (targets[kind]) {
      window.open(targets[kind], '_blank', 'noopener,noreferrer');
    }
  }

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(product.url || location.href);
    } catch (_) {
      const ta = document.createElement('textarea');
      ta.value = product.url || location.href;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }

    toast('Länk kopierad');
  }

  async function nativeShare() {
    if (navigator.share) {
      try {
        await navigator.share({
          title: product.title,
          text: product.title + ' – ' + money(product.price),
          url: product.url || location.href
        });
        return;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
      }
    }

    copyLink();
  }

  async function shareToSocialApp(app) {
    const label = app === 'instagram' ? 'Instagram' : 'TikTok';

    if (navigator.share) {
      try {
        await navigator.share({
          title: product.title,
          text: product.title + ' – ' + money(product.price),
          url: product.url || location.href
        });
        return;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
      }
    }

    await copyLink();
    toast('Länk kopierad – klistra in i ' + label);
  }

  let overlay = null;
  let panelPrevHtmlOverflow = '';
  let panelPrevBodyOverflow = '';

  function renderPanelCompare() {
    if (!overlay) return;

    const list = getCompare();
    const holder = overlay.querySelector('[data-pmvt-selected-list]');
    const count = overlay.querySelector('[data-pmvt-selected-count]');
    const actions = overlay.querySelector('[data-pmvt-selection-actions]');
    const limit = overlay.querySelector('[data-pmvt-selection-limit]');
    if (!holder || !actions) return;

    if (count) count.textContent = list.length + ' av 3 valda';

    holder.innerHTML = list.length
      ? list.map(item =>
          '<div class="pmvt-selected-card">' +
            (item.image
              ? '<img class="pmvt-selected-image" src="' + esc(item.image) + '" alt="">'
              : '<span class="pmvt-selected-image" aria-hidden="true"></span>') +
            '<div class="pmvt-selected-details">' +
              '<strong>' + esc(item.title || 'Fordon') + '</strong>' +
              '<small>' + esc(item.price || '') + '</small>' +
            '</div>' +
            '<button type="button" class="pmvt-selected-remove" data-pmvt-panel-remove="' + esc(item.id) + '" aria-label="Ta bort ' + esc(item.title || 'fordonet') + '">Ta bort</button>' +
          '</div>'
        ).join('')
      : '<div class="pmvt-selection-empty">Du har inte valt något fordon. Öppna ett fordon och tryck på Jämför.</div>';

    const currentNotSelected = !isCurrentCompared();
    actions.innerHTML =
      (list.length
        ? '<button type="button" class="pmvt-action pmvt-action--primary" data-pmvt-panel-compare>Visa jämförelse (' + list.length + ')</button>'
        : '') +
      (list.length < 3 && currentNotSelected
        ? '<button type="button" class="pmvt-action pmvt-action--primary" data-pmvt-panel-add>Jämför detta fordon</button>'
        : '') +
      (list.length < 3
        ? '<a class="pmvt-action" href="' + esc(collectionReturnUrl()) + '">+ Hitta fler fordon</a>'
        : '');

    // Avoid an orphan half-width button; keeps the panel balanced on all screens.
    actions.style.gridTemplateColumns = actions.children.length === 1 ? '1fr' : '1fr 1fr';
    if (limit) {
      limit.hidden = list.length < 3;
      limit.textContent = 'Max 3 fordon. Ta bort ett ovan för att välja ett annat.';
    }
  }

  function buildPanel() {
    overlay = document.createElement('div');
    overlay.className = 'pmvt-overlay';

    overlay.innerHTML = `
      <div class="pmvt-panel" role="dialog" aria-modal="true" aria-label="Fordon och dokument">
        <div class="pmvt-head">
          <div>
            <strong>Fordon & dokument</strong>
            <small>Hantera jämförelsen och skriv ut fordonsblad</small>
          </div>
          <button type="button" class="pmvt-close" data-pmvt-close aria-label="Stäng">×</button>
        </div>

        <div class="pmvt-body">
          <div class="pmvt-section">
            <div class="pmvt-selection-header">
              <p class="pmvt-label">Mina jämförda fordon</p>
              <span class="pmvt-selection-count" data-pmvt-selected-count></span>
            </div>
            <div class="pmvt-selected-list" data-pmvt-selected-list></div>
            <div class="pmvt-selection-actions" data-pmvt-selection-actions></div>
            <p class="pmvt-selection-limit" data-pmvt-selection-limit hidden></p>
          </div>

          <div class="pmvt-section">
            <p class="pmvt-label">Dokument</p>
            <button type="button" class="pmvt-action pmvt-document-card" data-pmvt-print>
              <span class="pmvt-action__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M7 3h10v6H7z"/>
                  <path d="M6 14h12v7H6z"/>
                  <path d="M5 9h14a2 2 0 0 1 2 2v5h-3"/>
                </svg>
              </span>
              <span>
                <strong>Fordonsblad</strong>
                <small>Skriv ut eller spara PDF</small>
              </span>
            </button>
          </div>
        </div>
      </div>`;

    document.body.appendChild(overlay);

    overlay.addEventListener('click', e => {
      if (e.target === overlay || e.target.closest('[data-pmvt-close]')) {
        closePanel();
        return;
      }

      const remove = e.target.closest('[data-pmvt-panel-remove]');
      if (remove) {
        setCompare(getCompare().filter(item =>
          String(item.id) !== String(remove.dataset.pmvtPanelRemove)
        ));
        return;
      }

      if (e.target.closest('[data-pmvt-panel-add]')) {
        if (getCompare().length < 3) addCurrentToCompare();
        closePanel();
        openCompare();
        return;
      }

      if (e.target.closest('[data-pmvt-panel-compare]')) {
        closePanel();
        openCompare();
        return;
      }

      if (e.target.closest('[data-pmvt-print]')) {
        printVehicleSheet();
      }
    });
  }

  function openPanel() {
    if (!overlay) buildPanel();
    renderPanelCompare();
    updateCompareButton();

    panelPrevHtmlOverflow = document.documentElement.style.overflow || '';
    panelPrevBodyOverflow = document.body.style.overflow || '';
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    if (!overlay || !overlay.classList.contains('is-open')) return;

    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = panelPrevHtmlOverflow;
    document.body.style.overflow = panelPrevBodyOverflow;
  }

  function addToolsButton() {
    const actions = $('.pmvp__top-actions');
    if (!actions) return;

    // The product section deliberately leaves this area empty for this asset.
    // Remove any controls injected by a previous copy, then insert one row.
    actions.querySelectorAll(
      '[data-pmvt-more],[data-pmvt-compare],[data-pmvt-native-share],.pmvt-more,.pmvt-tool-button'
    ).forEach(el => el.remove());

    const compareButton = document.createElement('button');
    compareButton.type = 'button';
    compareButton.className = 'pmvt-tool-button pmvt-tool-button--compare';
    compareButton.dataset.pmvtCompare = '1';
    compareButton.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M8 4h8M6 8h12M4 12h16M7 16h10M10 20h4"/>' +
      '</svg>' +
      '<span>Jämför</span>' +
      '<span class="pmvt-count" data-pmvt-compare-count hidden></span>';
    compareButton.addEventListener('click', () => {
      // A full comparison always opens as-is; never try to add a fourth vehicle.
      if (!isCurrentCompared() && getCompare().length < 3) {
        addCurrentToCompare();
      }
      updateCompareButton();
      openCompare();
    });

    const shareButton = document.createElement('button');
    shareButton.type = 'button';
    shareButton.className = 'pmvt-tool-button pmvt-tool-button--share';
    shareButton.dataset.pmvtNativeShare = '1';
    shareButton.setAttribute('aria-label', 'Dela fordonet');
    shareButton.title = 'Dela fordonet';
    shareButton.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M12 16V4M8 8l4-4 4 4"/>' +
        '<path d="M5 12v7h14v-7"/>' +
      '</svg>' +
      '<span>Dela</span>';
    shareButton.addEventListener('click', nativeShare);

    const moreButton = document.createElement('button');
    moreButton.type = 'button';
    moreButton.className = 'pmvt-tool-button pmvt-tool-button--more';
    moreButton.dataset.pmvtMore = '1';
    moreButton.setAttribute('aria-label', 'Fordon och dokument');
    moreButton.title = 'Fler alternativ';
    moreButton.setAttribute('aria-haspopup', 'dialog');
    moreButton.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<circle cx="5" cy="12" r="1.8" fill="currentColor" stroke="none"/>' +
        '<circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none"/>' +
        '<circle cx="19" cy="12" r="1.8" fill="currentColor" stroke="none"/>' +
      '</svg>';
    moreButton.addEventListener('click', openPanel);

    const printButton = document.createElement('button');
    printButton.type = 'button';
    printButton.className = 'pmvt-tool-button pmvt-tool-button--print';
    printButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h9l4 4v14H6zM14 3v5h5M9 12h7M9 16h7"/></svg><span>Produktblad / PDF</span>';
    printButton.addEventListener('click', printVehicleSheet);
    actions.append(printButton, shareButton, compareButton, moreButton);
    updateCompareButton();
  }

  renderCollectionBreadcrumb();
  addToolsButton();

  window.addEventListener('storage', e => {
    if (e.key !== COMPARE_KEY) return;
    updateCompareButton();
    if (overlay && overlay.classList.contains('is-open')) renderPanelCompare();
    if (compareModal && compareModal.classList.contains('is-open')) renderCompare();
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closePanel();
    closeCompare();
  });
})();

/* ================================================================
 * PAULS MOTOR | FINANSIERING + RESERVATION | REPARATION 2026-09-17
 * Isolerad från fordonsjämförelse, filter och provkörning.
 * Läser befintliga data-attribut i vehicle-produktsektionen.
 * Tar över endast trasiga kalkyl-/reservationskontroller.
 * ================================================================ */
(() => {
  'use strict';
  const INIT_KEY = 'pmvFinanceReserveRepair20260917B';
  const formatter = new Intl.NumberFormat('sv-SE', {maximumFractionDigits: 0});
  const number = raw => {
    const n = Number(String(raw == null ? '' : raw).replace(/\s/g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  };
  const cash = amount => formatter.format(Math.round(amount)) + ' kr';

  function init() {
    document.querySelectorAll('[data-pmvp-root]').forEach(root => {
      if (root.dataset[INIT_KEY] === '1') return;
      root.dataset[INIT_KEY] = '1';
      const $ = (selector, scope = root) => scope.querySelector(selector);
      const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
      const price = number(root.dataset.priceSek);
      const financeModal = $('[data-pmvp-modal="finance"]');
      const reserveModal = $('[data-pmvp-modal="reserve"]');
      const minPct = Math.max(20, Number.isFinite(number(root.dataset.financeMinDeposit)) ? number(root.dataset.financeMinDeposit) : 20);
      const rate = number(root.dataset.financeRate);
      const monthlyFee = number(root.dataset.financeMonthlyFee);
      const setupFee = number(root.dataset.financeSetupFee);
      const defaultTerm = Number(root.dataset.financeDefaultTerm || 84);
      const terms = $$('[data-finance-term]', financeModal || root)
        .map(button => number(button.dataset.financeTerm))
        .filter(n => Number.isInteger(n) && n > 0 && n <= defaultTerm);
      const finance = {
        term: defaultTerm,
        deposit: Number.isFinite(price) ? Math.round(price * minPct / 100) : 0
      };
      const minDeposit = () => price * minPct / 100;
      const renderText = (selector, value, scope = financeModal || root) => {
        const element = $(selector, scope);
        if (element) element.textContent = String(value);
      };
      const renderValue = (selector, value) => {
        const element = $(selector, financeModal || root);
        if (element) element.value = String(value);
      };
      function error(message) {
        const box = $('[data-finance-error]', financeModal || root);
        if (!box) return;
        box.hidden = !message;
        box.textContent = message || '';
      }
      function calculation(deposit, term) {
        if (!(Number.isFinite(price) && price > 0 && Number.isFinite(rate) && rate >= 0 &&
              Number.isFinite(monthlyFee) && monthlyFee >= 0 && Number.isFinite(setupFee) && setupFee >= 0 &&
              Number.isFinite(term) && term > 0)) return null;
        const down = Math.min(price, Math.max(minDeposit(), deposit));
        const loan = price - down;
        const residualRaw = number(root.getAttribute('data-residual-' + term));
        const residualPct = Number.isFinite(residualRaw) ? Math.max(0, Math.min(100, residualRaw)) : 0;
        const residual = Math.min(loan, price * residualPct / 100);
        const r = rate / 1200;
        const base = loan <= 0 ? 0 : r <= 0
          ? Math.max(0, (loan - residual) / term)
          : (loan - residual / Math.pow(1 + r, term)) * r / (1 - Math.pow(1 + r, -term));
        const monthly = base + monthlyFee;
        const creditCost = Math.max(0, base * term + residual + setupFee + monthlyFee * term - loan);
        if (![monthly, creditCost, residual].every(Number.isFinite)) return null;
        return { down, loan, residual, residualPct, monthly, creditCost };
      }
      function preview() {
        const example = calculation(minDeposit(), defaultTerm);
        if (!example) return;
        // Förhandspriset använder fordonets standardlöptid.
        renderText('[data-pmvp-hero-monthly]', formatter.format(Math.round(example.monthly)), root);
        renderText('[data-pmvp-hero-meta]', minPct + ' % kontantinsats · ' + defaultTerm + ' mån', root);
      }
      function render() {
        if (!financeModal) return;
        if (!Number.isFinite(price) || price <= 0) {
          error('Fordonets pris saknas. Kontakta Pauls Motor för ett finansieringsförslag.');
          return;
        }
        finance.deposit = Math.min(price, Math.max(minDeposit(), finance.deposit));
        const calc = calculation(finance.deposit, finance.term);
        if (!calc) {
          error('Finansieringsvillkoren kunde inte läsas. Kontakta Pauls Motor.');
          return;
        }
        error('');
        renderText('[data-finance-monthly]', formatter.format(Math.round(calc.monthly)));
        renderText('[data-finance-term-label]', finance.term);
        renderText('[data-finance-residual-label]', calc.residualPct);
        renderText('[data-finance-term-row]', finance.term);
        renderText('[data-finance-price]', cash(price));
        renderText('[data-finance-deposit-row]', '− ' + cash(calc.down));
        renderText('[data-finance-loan]', cash(calc.loan));
        renderText('[data-finance-residual-row]', cash(calc.residual));
        renderText('[data-finance-credit-cost]', cash(calc.creditCost));
        renderValue('[data-finance-hidden-monthly]', Math.round(calc.monthly) + ' kr/mån');
        renderValue('[data-finance-hidden-deposit]', Math.round(calc.down) + ' kr');
        renderValue('[data-finance-hidden-term]', finance.term + ' månader');
        renderValue('[data-finance-hidden-residual]', calc.residualPct + '% / ' + Math.round(calc.residual) + ' kr');
        const amount = $('[data-finance-deposit]', financeModal);
        if (amount && document.activeElement !== amount) amount.value = String(Math.round(calc.down));
        $$('[data-finance-term]', financeModal).forEach(button => {
          const active = Number(button.dataset.financeTerm) === finance.term;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        $$('[data-deposit-percent]', financeModal).forEach(button => {
          const active = Math.abs(calc.down - price * number(button.dataset.depositPercent) / 100) < 2;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        preview();
      }
      function solve() {
        const input = $('[data-finance-max-payment]', financeModal);
        const target = input ? number(input.value) : NaN;
        if (!Number.isFinite(target) || target <= 0) {
          error('Ange en månadskostnad som är större än 0 kr.');
          if (input) input.focus();
          return;
        }
        const minimum = calculation(minDeposit(), finance.term);
        const maximum = calculation(price, finance.term);
        if (!minimum || !maximum) return render();
        if (target < maximum.monthly - 0.001) {
          error('Beloppet understiger aviavgiften. Välj en högre månadskostnad.');
          return;
        }
        if (minimum.monthly <= target) {
          finance.deposit = minDeposit();
          render();
          error('Minsta kontantinsatsen räcker för den månadskostnaden.');
          return;
        }
        let low = minDeposit();
        let high = price;
        for (let i = 0; i < 50; i++) {
          const mid = (low + high) / 2;
          if (calculation(mid, finance.term).monthly > target) low = mid;
          else high = mid;
        }
        // Avrunda uppåt så att det visade beloppet inte överstiger målet.
        finance.deposit = Math.min(price, Math.ceil(high / 100) * 100);
        render();
      }
      if (financeModal) {
        // Capture stoppar gamla, eventuellt defekta knapplyssnare på samma kontroller.
        root.addEventListener('click', event => {
          const button = event.target.closest('[data-finance-term],[data-deposit-percent],[data-finance-solve]');
          if (!button || !financeModal.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          if (button.hasAttribute('data-finance-term')) {
            const next = number(button.dataset.financeTerm);
            if (terms.includes(next)) finance.term = next;
            render();
          } else if (button.hasAttribute('data-deposit-percent')) {
            const next = number(button.dataset.depositPercent);
            if (Number.isFinite(next)) finance.deposit = Math.round(price * Math.max(minPct, next) / 100);
            render();
          } else solve();
        }, true);
        const amount = $('[data-finance-deposit]', financeModal);
        if (amount) {
          // Sätt inte tillbaka ett ofärdigt värde medan kunden skriver.
          amount.addEventListener('input', event => {
            event.stopImmediatePropagation();
            const next = number(amount.value);
            if (Number.isFinite(next)) finance.deposit = Math.min(price, Math.max(minDeposit(), next));
            render();
          }, true);
          amount.addEventListener('change', event => {
            event.stopImmediatePropagation();
            const next = number(amount.value);
            if (Number.isFinite(next)) finance.deposit = Math.min(price, Math.max(minDeposit(), next));
            render();
          }, true);
        }
        root.addEventListener('click', event => {
          if (!event.target.closest('[data-pmvp-open="finance"]')) return;
          // Modalen öppnas av befintlig kod; uppdatera efter öppningen.
          queueMicrotask(render);
        });
        render();
      }
      preview();

      if (!reserveModal) return;
      const reserveForm = $('#PMVehicleReserveForm', reserveModal);
      const panels = $$('[data-reserve-panel]', reserveModal);
      if (!reserveForm || panels.length !== 4) return;
      const indicators = $$('[data-reserve-indicator]', reserveModal);
      const tradeToggle = $('[data-reserve-trade-toggle]', reserveModal);
      const tradeFields = $('[data-reserve-trade-fields]', reserveModal);
      const tradeReg = $('[data-reserve-trade-reg]', reserveModal);
      const tradeMileage = $('[data-reserve-trade-mileage]', reserveModal);

      // Ett gammalt CSS-display-värde kan annars slå ut HTML:s hidden-attribut.
      const tradeStyleId = 'pmvt-reserve-trade-visibility-20260917';
      if (!document.getElementById(tradeStyleId)) {
        const style = document.createElement('style');
        style.id = tradeStyleId;
        style.textContent = '[data-reserve-trade-fields][hidden]{display:none!important}';
        document.head.appendChild(style);
      }
      function syncTradeFields() {
        const selected = !!(tradeToggle && tradeToggle.checked);
        if (tradeFields) tradeFields.hidden = !selected;
        if (tradeReg) tradeReg.required = selected;
        if (tradeMileage) tradeMileage.required = selected;
      }
      if (tradeToggle) {
        tradeToggle.addEventListener('change', syncTradeFields, true);
        tradeToggle.addEventListener('input', syncTradeFields, true);
      }
      syncTradeFields();
      let step = 1;
      function showStep(next) {
        step = Math.max(1, Math.min(4, next));
        syncTradeFields();
        panels.forEach(panel => panel.classList.toggle('is-active', Number(panel.dataset.reservePanel) === step));
        indicators.forEach(indicator => {
          const value = Number(indicator.dataset.reserveIndicator);
          indicator.classList.toggle('is-current', value === step);
          indicator.classList.toggle('is-done', value < step);
        });
        const back = $('[data-reserve-back]', reserveModal);
        const nextButton = $('[data-reserve-next]', reserveModal);
        const submit = $('[data-reserve-submit]', reserveModal);
        if (back) back.hidden = step === 1;
        if (nextButton) nextButton.hidden = step === 4;
        if (submit) submit.hidden = step !== 4;
        if (step === 4) summary();
        const dialogBody = $('.pmvp-dialog__body', reserveModal);
        if (dialogBody) dialogBody.scrollTop = 0;
      }
      function isVisibleField(field) {
        return !field.disabled && field.type !== 'hidden' && !field.closest('[hidden]') &&
          getComputedStyle(field).display !== 'none';
      }
      function validate(activeStep) {
        const panel = panels.find(p => Number(p.dataset.reservePanel) === activeStep);
        if (!panel) return false;
        const field = $$('input,select,textarea', panel)
          .find(control => isVisibleField(control) && !control.checkValidity());
        if (field) {
          if (typeof field.reportValidity === 'function') field.reportValidity();
          if (typeof field.focus === 'function') field.focus();
          return false;
        }
        return true;
      }
      function text(selector) {
        const node = $(selector, reserveModal);
        return node ? String(node.value || '').trim() : '';
      }
      function chosen(name) {
        const node = $$('input[type="radio"]', reserveModal).find(r => r.name === name && r.checked);
        return node ? node.value : '';
      }
      function summary() {
        const table = $('[data-reserve-summary]', reserveModal);
        if (!table) return;
        const swap = $('[data-reserve-trade-toggle]', reserveModal);
        const trade = swap && swap.checked
          ? [text('[data-reserve-trade-reg]'), text('[data-reserve-trade-mileage]') && text('[data-reserve-trade-mileage]') + ' mil'].filter(Boolean).join(' · ')
          : 'Nej';
        const delivery = chosen('contact[Leverans]');
        const deliveryText = delivery === 'Transport med Frakta Sverige'
          ? delivery + ' · Bokas separat efter bekräftat köp' : delivery;
        const addons = $$('[data-reserve-addon]:checked', reserveModal).map(node =>
          (node.closest('label')?.querySelector('strong')?.textContent || node.value || '').trim()
        ).filter(Boolean).join(', ');
        const rows = [
          ['Fordon', root.dataset.productTitle || ''],
          ['Pris', Number.isFinite(price) && price > 0 ? cash(price) : 'Kontakta oss'],
          ['Namn', text('[data-reserve-name]')],
          ['Kontakt', [text('[data-reserve-email]'), text('[data-reserve-phone]')].filter(Boolean).join(' · ')],
          ['Leverans', deliveryText],
          ['Betalning', chosen('contact[Betalning]')],
          ['Inbyte', trade],
          ['Tillval', addons || 'Inga']
        ];
        table.replaceChildren(...rows.map(([label, value]) => {
          const row = document.createElement('div');
          const key = document.createElement('span');
          const val = document.createElement('strong');
          key.textContent = label;
          val.textContent = value;
          row.append(key, val);
          return row;
        }));
      }
      // Behåll originalformulärets Shopify-postning – skicka aldrig via ett nytt API.
      root.addEventListener('click', event => {
        const nextButton = event.target.closest('[data-reserve-next]');
        const backButton = event.target.closest('[data-reserve-back]');
        if ((!nextButton && !backButton) || !reserveModal.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        if (backButton) showStep(step - 1);
        else if (validate(step)) showStep(step + 1);
      }, true);
      reserveForm.addEventListener('submit', event => {
        if (step !== 4 || !validate(4)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        // Den gamla sektionskoden kan fortfarande ha step=1 och blockera
        // korrekt submit. Stoppa dess submit-listener, inte själva POST:en.
        event.stopImmediatePropagation();
      }, true);
      root.addEventListener('click', event => {
        if (event.target.closest('[data-pmvp-open="reserve"]')) queueMicrotask(() => showStep(1));
      });
      showStep(1);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

/* ================================================================
 * PAULS MOTOR | KORREKT BEKRÄFTELSE PER FORMULÄR | 2026-09-17
 * Shopify kan sätta form.posted_successfully? på ALLA kontaktformulär
 * efter att ETT skickats. Bekräftelsen visas därför endast för
 * det formulär som faktiskt skickades, och bara efter ett lyckat POST.
 * Ingen ändring av Shopify-CAPTCHA eller formulärens POST-anrop.
 * ================================================================ */
(() => {
  'use strict';

  const FORM_TYPES = Object.freeze({
    PMVehicleFinanceForm: 'finance',
    PMVehicleReserveForm: 'reserve',
    PMVehicleInterestForm: 'interest',
    PMVehicleTestDriveForm: 'testdrive'
  });
  const KEY = 'pmvt_vehicle_contact_pending_v1';
  const TTL = 20 * 60 * 1000;

  function boot() {
    document.querySelectorAll('[data-pmvp-root]').forEach(root => {
      if (root.hasAttribute('data-pmvp-unified-requests') || root.dataset.pmvtSuccessGuard20260917 === '1') return;
      root.dataset.pmvtSuccessGuard20260917 = '1';

      const messages = Array.from(root.querySelectorAll('[data-pmvp-success]'));
      if (!messages.length) return;

      const styleId = 'pmvt-success-guard-style';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = '[data-pmvp-root] [data-pmvp-success]:not(.pmvt-success-authorized){display:none!important}';
        document.head.appendChild(style);
      }

      function showOnly(type) {
        messages.forEach(message => {
          const permitted = !!type && message.dataset.pmvpSuccess === type;
          message.classList.toggle('pmvt-success-authorized', permitted);
          message.hidden = !permitted;
        });
      }

      function readPending() {
        try {
          const value = JSON.parse(sessionStorage.getItem(KEY) || 'null');
          if (!value || !Object.hasOwn(FORM_TYPES, value.id) ||
              value.type !== FORM_TYPES[value.id] ||
              value.path !== location.pathname ||
              !Number.isFinite(value.at) ||
              Date.now() - value.at > TTL || value.at > Date.now() + 30000) return null;
          return value;
        } catch (_) { return null; }
      }

      function clearPending() {
        try { sessionStorage.removeItem(KEY); } catch (_) {}
      }

      // Registrera vilket av sidans kontaktformulär som skickas.
      // Händelsen observeras, inte avbryts: Shopifys CAPTCHA används som vanligt.
      root.addEventListener('submit', event => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !Object.hasOwn(FORM_TYPES, form.id)) return;
        try {
          sessionStorage.setItem(KEY, JSON.stringify({
            id: form.id,
            type: FORM_TYPES[form.id],
            path: location.pathname,
            at: Date.now()
          }));
        } catch (_) {}
      }, true);

      const params = new URLSearchParams(location.search);
      const accepted = params.get('contact_posted') === 'true';
      const pending = readPending();
      let hashId = '';
      try { hashId = decodeURIComponent(location.hash.slice(1)); }
      catch (_) { hashId = location.hash.slice(1); }
      const knownHash = Object.hasOwn(FORM_TYPES, hashId);

      // Kräver Shopifys lyckade kontakt-POST. Identifiera det skickade formuläret
      // via exakt formulärankare eller det senaste verkliga submit-eventet.
      // Vid motstridiga uppgifter visas INGEN bekräftelse.
      let authorized = null;
      if (accepted) {
        if (pending) {
          if (!knownHash || hashId === pending.id) authorized = pending.type;
        } else if (knownHash) {
          authorized = FORM_TYPES[hashId];
        }
      }
      if (authorized && !messages.some(message => message.dataset.pmvpSuccess === authorized)) {
        authorized = null;
      }

      showOnly(authorized);
      clearPending();

      let dismissed = false;
      let autoOpening = false;

      // När kunden väljer ett nytt ärende ska gamla tackmeddelanden inte
      // följa med. Gäller även om Shopify lämnat ?contact_posted=true kvar.
      root.addEventListener('click', event => {
        const opener = event.target.closest('[data-pmvp-open]');
        if (!opener || !root.contains(opener) || autoOpening) return;
        dismissed = true;
        authorized = null;
        showOnly(null);
        try {
          const url = new URL(location.href);
          url.searchParams.delete('contact_posted');
          if (Object.hasOwn(FORM_TYPES, url.hash.slice(1)) || url.hash === '#contact_form') {
            url.hash = '';
          }
          history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        } catch (_) {}
      }, true);

      // Vissa Shopify-teman returnerar #contact_form i stället för det unika
      // formulär-ID:t. Öppna då rätt dialog utan att låtsas att övriga skickats.
      if (authorized && !knownHash) {
        const type = authorized;
        setTimeout(() => {
          if (dismissed) return;
          const modal = root.querySelector('[data-pmvp-modal="' + type + '"]');
          if (!modal || modal.classList.contains('is-open')) return;
          const opener = root.querySelector('[data-pmvp-open="' + type + '"]');
          if (!opener) return;
          autoOpening = true;
          try { opener.click(); }
          finally { autoOpening = false; }
          if (!dismissed) showOnly(type);
        }, 140);
      }

      // Förhindra att omladdning eller delning av en gammal lyckad URL
      // visar ett nytt tackmeddelande. Låt först temats egen returhantering köras.
      if (accepted) {
        setTimeout(() => {
          if (dismissed) return;
          try {
            const url = new URL(location.href);
            url.searchParams.delete('contact_posted');
            if (Object.hasOwn(FORM_TYPES, url.hash.slice(1)) || url.hash === '#contact_form') {
              url.hash = '';
            }
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
          } catch (_) {}
        }, 500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {once: true});
  } else {
    boot();
  }
})();


/* ================================================================
 * PAULS MOTOR | RESERVATION | TYDLIG STEGINDIKATOR + PRODUKTKORT
 * Presentation only: no changes to submit, validation or CAPTCHA.
 * ================================================================ */
(() => {
  'use strict';
  const STYLE_ID = 'pmvt-reserve-layout-clean-20260917';
  const LABELS = ['Dina uppgifter', 'Betalning', 'Inbyte & tillval', 'Bekräfta'];

  function addCss() {
    if (document.getElementById(STYLE_ID)) return;
    const el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = `
      [data-pmvp-modal="reserve"] .pmvt-native-stepper-hidden{display:none!important}
      [data-pmvp-modal="reserve"] .pmvt-clean-stepper{
        box-sizing:border-box!important;
        display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;
        align-items:center!important;gap:8px!important;
        width:100%!important;min-width:0!important;
        margin:12px 0 24px!important;padding:0!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-clean-step{
        box-sizing:border-box!important;display:flex!important;align-items:center!important;
        justify-content:flex-start!important;gap:9px!important;
        min-width:0!important;padding:0!important;margin:0!important;
        background:transparent!important;border:0!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-clean-step__number{
        box-sizing:border-box!important;display:flex!important;align-items:center!important;
        justify-content:center!important;flex:0 0 34px!important;
        width:34px!important;height:34px!important;min-width:34px!important;
        border-radius:50%!important;background:#eef1f3!important;
        color:#596169!important;font:800 12px/1 system-ui,sans-serif!important;
        white-space:nowrap!important;overflow:visible!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-clean-step__label{
        display:block!important;min-width:0!important;flex:1 1 auto!important;
        color:#717980!important;font:750 11px/1.35 system-ui,sans-serif!important;
        overflow-wrap:normal!important;word-break:normal!important;
        white-space:normal!important;hyphens:none!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-clean-step.is-current .pmvt-clean-step__number{
        color:#fff!important;background:#f58220!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-clean-step.is-done .pmvt-clean-step__number{
        color:#fff!important;background:#128a4b!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-clean-step.is-current .pmvt-clean-step__label,
      [data-pmvp-modal="reserve"] .pmvt-clean-step.is-done .pmvt-clean-step__label{
        color:#191b1d!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-reserve-inline-summary{
        float:right!important;width:min(300px,36%)!important;
        box-sizing:border-box!important;margin:0 0 18px 24px!important;padding:12px!important;
        border:1px solid #e5e8eb!important;border-radius:16px!important;
        background:#fcfcfc!important;box-shadow:0 8px 22px rgba(0,0,0,.035)!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-reserve-inline-summary img{
        display:block!important;max-width:100%!important;
        border-radius:10px!important;object-fit:cover!important;
      }
      [data-pmvp-modal="reserve"] .pmvt-reserve-summary-original{display:none!important}
      [data-pmvp-modal="reserve"] .pmvt-reserve-clearfix{clear:both!important;height:0!important}
      @media(max-width:720px){
        [data-pmvp-modal="reserve"] .pmvt-clean-stepper{gap:5px!important;margin:8px 0 16px!important}
        [data-pmvp-modal="reserve"] .pmvt-clean-step{
          flex-direction:column!important;align-items:center!important;gap:5px!important;
          text-align:center!important;
        }
        [data-pmvp-modal="reserve"] .pmvt-clean-step__number{
          width:30px!important;height:30px!important;min-width:30px!important;flex-basis:30px!important;
        }
        [data-pmvp-modal="reserve"] .pmvt-clean-step__label{font-size:10px!important;line-height:1.3!important}
        [data-pmvp-modal="reserve"] .pmvt-reserve-inline-summary{
          float:none!important;width:100%!important;margin:0 0 16px!important;
        }
      }
    `;
    document.head.appendChild(el);
  }

  function findNativeStepper(modal, indicators) {
    // The smallest ancestor containing all four markers is the native row.
    // Never hide an ancestor that contains the form, a panel or the bike photo.
    let node = indicators[0].parentElement;
    while (node && !indicators.every(indicator => node.contains(indicator))) node = node.parentElement;
    if (!node || node === modal || node.tagName === 'FORM' ||
        node.querySelector('[data-reserve-panel]') || node.querySelector('img')) return null;
    return node;
  }

  function installStepper(modal) {
    const indicators = Array.from(modal.querySelectorAll('[data-reserve-indicator]'))
      .sort((a, b) => Number(a.dataset.reserveIndicator) - Number(b.dataset.reserveIndicator));
    if (indicators.length !== 4) return;
    const native = findNativeStepper(modal, indicators);
    if (!native || modal.querySelector('.pmvt-clean-stepper')) return;

    const bar = document.createElement('nav');
    bar.className = 'pmvt-clean-stepper';
    bar.setAttribute('aria-label', 'Reservationssteg');
    LABELS.forEach((label, index) => {
      const step = document.createElement('div');
      step.className = 'pmvt-clean-step';
      step.dataset.pmvtVisualStep = String(index + 1);
      const number = document.createElement('span');
      number.className = 'pmvt-clean-step__number';
      number.textContent = String(index + 1);
      number.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'pmvt-clean-step__label';
      text.textContent = label;
      step.append(number, text);
      bar.appendChild(step);
    });
    native.before(bar);
    native.classList.add('pmvt-native-stepper-hidden');

    function sync() {
      indicators.forEach((indicator, index) => {
        const step = bar.children[index];
        const active = indicator.classList.contains('is-current');
        const done = indicator.classList.contains('is-done');
        step.classList.toggle('is-current', active);
        step.classList.toggle('is-done', done);
        if (active) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
    }
    sync();
    const observer = new MutationObserver(sync);
    indicators.forEach(indicator => observer.observe(indicator, {attributes:true, attributeFilter:['class']}));
  }

  function installSummary(modal, root) {
    // Keep the existing bike summary, but place its visual copy beside step 1.
    const form = modal.querySelector('#PMVehicleReserveForm');
    const panel = modal.querySelector('[data-reserve-panel="1"]');
    if (!form || !panel || modal.querySelector('.pmvt-reserve-inline-summary')) return;

    const title = String(root.dataset.productTitle || '').trim();
    const reg = String(root.dataset.reg || '').trim();
    let best = null;
    let score = 0;
    modal.querySelectorAll('div,section,article,aside').forEach(el => {
      if (el === form || el.contains(form) || !el.querySelector('img') ||
          el.querySelector('[data-reserve-panel]') || el.querySelector('[data-reserve-indicator]')) return;
      const txt = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt.length > 280) return;
      let n = (title && txt.includes(title) ? 6 : 0) +
              (reg && txt.includes(reg) ? 3 : 0) +
              (/\bkr\b/.test(txt) ? 2 : 0);
      if (/reservera fordonet|fullständigt namn|frakta sverige/i.test(txt)) n -= 8;
      if (n > score) { score = n; best = el; }
    });
    if (!best || score < 4) return;
    const duplicate = best.cloneNode(true);
    duplicate.classList.add('pmvt-reserve-inline-summary');
    duplicate.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    best.classList.add('pmvt-reserve-summary-original');
    panel.before(duplicate);
    const clear = document.createElement('div');
    clear.className = 'pmvt-reserve-clearfix';
    // Clear the summary float before navigation controls on step 1.
    panel.after(clear);
  }

  function init() {
    document.querySelectorAll('[data-pmvp-root]').forEach(root => {
      const modal = root.querySelector('[data-pmvp-modal="reserve"]');
      if (!modal || modal.dataset.pmvtReserveLayoutClean === '1') return;
      modal.dataset.pmvtReserveLayoutClean = '1';
      addCss();
      installStepper(modal);
      installSummary(modal, root);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else init();
})();


/* PAULS MOTOR | SVEDEA MC V4 – CONTACT TAB | 2026-10-30
 * Direct browser hand-off. No customer data in storage, URLs or analytics.
 * The observed Svedea web endpoint is not a versioned partner API.
 */
(() => {
  'use strict';
  const KEY = '__pmSvedeaInsuranceV1';
  if (window[KEY]) { window[KEY].scan(document); return; }
  const instances = new Map();
  const ENDPOINT = 'https://app.svedea.se/start/Offert';
  const REG_PATTERN = /^[A-Z]{3}[0-9]{2}[A-Z0-9]$/;

  function normalizePersonalNumber(value) {
    const text = String(value).trim();
    if (!/^(?:\d{8}-?\d{4}|\d{6}[-+]?\d{4})$/.test(text)) return null;
    const digits = text.replace(/[-+]/g, '');
    const short = digits.slice(-10);
    const month = Number(short.slice(2, 4));
    const day = Number(short.slice(4, 6));
    const today = new Date();
    let year = digits.length === 12 ? Number(digits.slice(0, 4)) : Math.floor(today.getFullYear() / 100) * 100 + Number(short.slice(0, 2));
    if (digits.length === 10 && Date.UTC(year, month - 1, day) > today.getTime()) year -= 100;
    if (text.includes('+')) year -= 100;
    const date = new Date(Date.UTC(year, month - 1, day));
    if (year < 1800 || date.getTime() > today.getTime() || date.getUTCFullYear() !== year ||
        date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    const sum = [...short].reduce((total, char, i) => {
      const n = Number(char) * (i % 2 === 0 ? 2 : 1);
      return total + (n > 9 ? n - 9 : n);
    }, 0);
    if (sum % 10 !== 0) return null;
    // Svedea requires exactly ten digits, including when the customer enters twelve.
    return short;
  }

  function svedeaError(data) {
    const entries = Array.isArray(data) ? data : data && typeof data === 'object' ? [data] : [];
    const messages = entries.map(item => item && (item.messagetext || item.message))
      .filter(value => typeof value === 'string' && value.trim() && value.length <= 800)
      .map(value => value.replace(/\b(?:\d{8}[-+]?\d{4}|\d{6}[-+]\d{4}|\d{10})\b/g, '[personnummer]')
        .replace(/\b[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}\b/ig, '[ärende-id]')
        .replace(/\s+/g, ' ').trim());
    const error = new Error('svedea-response');
    error.userMessage = messages.length
      ? 'Svedea meddelar: ' + [...new Set(messages)].slice(0, 3).join(' ')
      : 'Svedea kunde inte starta beräkningen just nu. Försök igen eller fortsätt på Svedeas webbplats.';
    return error;
  }

  function offerUrl(value) {
    if (typeof value !== 'string') throw new Error('invalid-response');
    const url = new URL(value);
    if (url.origin !== 'https://app.svedea.se' || url.username || url.password || url.hash ||
        !/^\/start\/offert$/i.test(url.pathname) || [...url.searchParams.keys()].length !== 1 ||
        !/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(url.searchParams.get('id') || '')) {
      throw new Error('invalid-response');
    }
    return url.href;
  }

  function install(root) {
    if (instances.has(root)) return;
    const cleanups = [...root.querySelectorAll('[data-pm-svedea-dialog],[data-pm-svedea-inline]')]
      .map(surface => installSurface(root, surface)).filter(Boolean);
    if (cleanups.length) instances.set(root, () => {
      cleanups.forEach(cleanup => cleanup());
      instances.delete(root);
    });
  }

  function installSurface(root, dialog) {
    const inline = dialog.hasAttribute('data-pm-svedea-inline');
    const card = inline ? null : root.querySelector('[data-pm-svedea-card]');
    if (!inline && (!card || typeof dialog.showModal !== 'function')) return;
    const form = dialog.querySelector('form');
    const reg = dialog.querySelector('[data-pm-svedea-reg]');
    const person = dialog.querySelector('[data-pm-svedea-person]');
    person.placeholder = 'ÅÅMMDD-XXXX';
    const submit = dialog.querySelector('[data-pm-svedea-submit]');
    const error = dialog.querySelector('[data-pm-svedea-error]');
    const status = dialog.querySelector('[data-pm-svedea-status]');
    const result = dialog.querySelector('[data-pm-svedea-result]');
    const opener = card?.querySelector('[data-pm-svedea-open]');
    const close = dialog.querySelector('[data-pm-svedea-close]');
    const registration = String(root.dataset.reg || '').replace(/\s/g, '').toUpperCase();
    if (!REG_PATTERN.test(registration)) return;
    const events = new AbortController();
    let active = null;
    let readyUrl = null;
    let overflow = null;
    let visibilityObserver = null;
    reg.value = registration;

    function listen(target, type, handler) {
      target.addEventListener(type, handler, { signal: events.signal });
    }
    function busy(value) {
      submit.disabled = value;
      person.readOnly = value;
      form.setAttribute('aria-busy', String(value));
      submit.querySelector('span').textContent = value ? 'Hämtar ditt pris…' : readyUrl ? 'Öppna Svedea' : 'Se ditt pris';
    }
    function showError(message) {
      error.textContent = message;
      error.hidden = false;
      status.textContent = '';
    }
    function resetMessages() {
      readyUrl = null;
      error.hidden = true;
      error.textContent = '';
      status.textContent = '';
      result.hidden = true;
      result.removeAttribute('href');
      person.removeAttribute('aria-invalid');
      person.setCustomValidity('');
    }
    function cancelRequest() {
      if (!active) return;
      const request = active;
      active = null;
      clearTimeout(request.timer);
      request.controller.abort();
    }
    function openReadyOffer() {
      if (!readyUrl) return;
      let opened = false;
      try {
        // Open the actual Svedea URL only after the response is ready.
        // The navigation starts after this task; sever the opener immediately.
        const quoteTab = window.open(readyUrl, '_blank');
        if (quoteTab) { quoteTab.opener = null; opened = true; }
      } catch (_) {}
      status.textContent = opened
        ? 'Svedea har öppnats i en ny flik. Fordonssidan finns kvar här.'
        : 'Klart! Klicka på ”Öppna Svedea” för att fortsätta.';
    }
    function unlock() {
      if (!overflow) return;
      if (overflow.value) document.documentElement.style.setProperty('overflow', overflow.value, overflow.priority);
      else document.documentElement.style.removeProperty('overflow');
      overflow = null;
    }
    function clear() {
      cancelRequest();
      person.value = '';
      resetMessages();
      busy(false);
      unlock();
    }
    if (!inline) {
      listen(opener, 'click', () => {
      if (dialog.open) return;
      clear();
      reg.value = registration;
      dialog.showModal();
      overflow = { value: document.documentElement.style.getPropertyValue('overflow'), priority: document.documentElement.style.getPropertyPriority('overflow') };
      document.documentElement.style.setProperty('overflow', 'hidden');
      person.focus({ preventScroll: true });
    });
    listen(close, 'click', () => { clear(); dialog.close(); });
    listen(dialog, 'cancel', () => { clear(); });
    listen(dialog, 'close', () => { clear(); if (opener.isConnected) opener.focus({ preventScroll: true }); });
    listen(dialog, 'keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button,input,a[href],[tabindex]')]
        .filter(el => !el.disabled && el.tabIndex >= 0 && !el.closest('[hidden]') && el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    // A real backdrop click must start AND end outside the dialog rectangle.
    let backdropDown = false;
    const outside = event => {
      const r = dialog.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    };
    listen(dialog, 'pointerdown', event => { backdropDown = event.target === dialog && outside(event); });
    listen(dialog, 'click', event => {
      if (backdropDown && event.target === dialog && outside(event)) { clear(); dialog.close(); }
      backdropDown = false;
    });
    } else {
      // The existing contact hub owns tab selection, focus trapping and scrolling.
      // Leaving the tab or closing the hub discards identifiers and pending requests.
      const panel = dialog.closest('[data-pmvp-request-panel]');
      const modal = dialog.closest('[data-pmvp-modal]');
      const clearWhenHidden = () => {
        if (panel?.hidden || modal?.getAttribute('aria-hidden') === 'true') clear();
      };
      visibilityObserver = new MutationObserver(clearWhenHidden);
      if (panel) visibilityObserver.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      if (modal) visibilityObserver.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    listen(person, 'input', () => { resetMessages(); if (!active) busy(false); });
    listen(window, 'pagehide', clear);
    listen(form, 'submit', async event => {
      event.preventDefault();
      if (active) return;
      if (readyUrl) { openReadyOffer(); return; }
      resetMessages();
      let personalNumber = normalizePersonalNumber(person.value);
      if (!personalNumber) {
        person.setAttribute('aria-invalid', 'true');
        showError('Kontrollera personnumret. Ange 10 eller 12 siffror, till exempel i formatet ÅÅMMDD-XXXX.');
        person.focus();
        return;
      }
      const request = { controller: new AbortController(), timer: null };
      active = request;
      busy(true);
      status.textContent = 'Svedea behandlar din förfrågan…';
      request.timer = setTimeout(() => request.controller.abort(), 20000);
      try {
        const responsePromise = fetch(ENDPOINT, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error',
          referrerPolicy: 'no-referrer', signal: request.controller.signal,
          headers: { 'Content-Type': 'application/json; charset=utf-8', Accept: 'application/json' },
          body: JSON.stringify([
            { key: 'registrationno', value: registration },
            { key: 'organizationno', value: personalNumber },
            { key: 'salesprocessno', value: '2' }
          ])
        });
        personalNumber = null;
        person.value = '';
        const response = await responsePromise;
        let responseData;
        try { responseData = await response.json(); } catch (_) {}
        if (!response.ok || typeof responseData !== 'string') throw svedeaError(responseData);
        const url = offerUrl(responseData);
        if (active !== request) return;
        result.href = url;
        result.hidden = false;
        readyUrl = url;
        openReadyOffer();
      } catch (failure) {
        if (active !== request) return;
        showError(failure.userMessage || 'Vi kunde inte ansluta till Svedea just nu. Försök igen eller fortsätt på Svedeas webbplats.');
      } finally {
        personalNumber = null;
        clearTimeout(request.timer);
        if (active === request) { active = null; busy(false); }
      }
    });
    if (card) card.hidden = false;
    return () => {
      clear();
      visibilityObserver?.disconnect();
      if (!inline) dialog.close();
      events.abort();
    };
  }
  function scan(scope) {
    if (scope.matches?.('[data-pmvp-root]')) install(scope);
    scope.querySelectorAll?.('[data-pmvp-root]').forEach(install);
  }
  window[KEY] = { scan };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) if (event.target === root || event.target.contains(root)) destroy();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
